/** 由 scripts/gen-locales.mjs 生成，请勿手改；文案请编辑 src/locales/source/ */
export default {
  "aiFeedback.conversation_id": "会话ID",
  "aiFeedback.created": "提交时间",
  "aiFeedback.detail": "详情",
  "aiFeedback.kind": "类型",
  "aiFeedback.message_id": "消息ID",
  "aiFeedback.model": "模型",
  "aiFeedback.platform": "平台",
  "aiFeedback.rating": "评分",
  "aiFeedback.result_id": "结果ID",
  "aiFeedback.result_text": "处理结果",
  "aiFeedback.role": "角色",
  "aiFeedback.source_language": "源语言",
  "aiFeedback.source_text": "原文／转写结果",
  "aiFeedback.suggestion": "建议内容",
  "aiFeedback.target": "目标语言",
  "aiFeedback.target_language": "目标语言",
  "aiFeedback.title": "翻译与转写反馈",
  "aiFeedback.transcription": "转写",
  "aiFeedback.translation": "翻译",
  "aiFeedback.user": "用户",
  "Bot促活推送.保存成功": "配置已保存",
  "Bot促活推送.保存生效": "保存生效",
  "Bot促活推送.最低岗位数": "最低岗位数",
  "Bot促活推送.刷新": "刷新",
  "Bot促活推送.历史文案未保存": "历史记录未保存发送文案",
  "Bot促活推送.发送失败": "发送失败",
  "Bot促活推送.发送成功": "发送成功",
  "Bot促活推送.发送日期": "发送日期",
  "Bot促活推送.发送时间": "发送时间",
  "Bot促活推送.发送时间校验": "请选择 08:00–21:59",
  "Bot促活推送.发送结果": "发送结果",
  "Bot促活推送.发送计划": "发送计划与文案",
  "Bot促活推送.发送记录": "发送记录",
  "Bot促活推送.取数说明": "少于10条不发送；10–19条显示15+，20–49条45+，50–99条80+，100条以上100+。有效月薪区间先取中值，再取连续P80；面议、缺失、无效金额不参与，展示月薪 $XX+。",
  "Bot促活推送.变量说明": "正文支持 {count}、{position}、{location}；薪资行支持 {salary}。",
  "Bot促活推送.后台总开关": "启用 Bot 定时促活",
  "Bot促活推送.启用": "启用此时段",
  "Bot促活推送.夜间免打扰说明": "北京时间，22:00–08:00 不发送",
  "Bot促活推送.失败原因": "失败原因",
  "Bot促活推送.岗位取数规则": "岗位取数规则",
  "Bot促活推送.岗位数量": "岗位数量",
  "Bot促活推送.已点击": "已点击 {count} 次",
  "Bot促活推送.总开关关闭": "当前环境的服务端总开关未开启，配置可以保存，但定时任务不会发送。",
  "Bot促活推送.打开试发": "打开 Bot 试发",
  "Bot促活推送.接收用户": "接收用户",
  "Bot促活推送.数量展示": "岗位数量展示",
  "Bot促活推送.数量展示.exact": "精确数量",
  "Bot促活推送.数量展示.range": "档位数量（15+ / 45+ / 80+ / 100+）",
  "Bot促活推送.新增策略": "新增策略",
  "Bot促活推送.新策略默认名称": "新促活策略",
  "Bot促活推送.是否点击": "是否点击",
  "Bot促活推送.未点击": "未点击",
  "Bot促活推送.未绑定用户": "未绑定 App 用户",
  "Bot促活推送.正文": "Bot 正文",
  "Bot促活推送.点击按钮": "按钮",
  "Bot促活推送.点击记录": "点击记录",
  "Bot促活推送.策略.fallback": "无画像频道导流",
  "Bot促活推送.策略.generic_jobs": "无画像通用岗位",
  "Bot促活推送.策略.jobs": "工种和区域画像频道导流",
  "Bot促活推送.策略.location_jobs": "区域匹配岗位",
  "Bot促活推送.策略.matched_jobs": "工种 + 区域匹配岗位",
  "Bot促活推送.策略.position_jobs": "工种匹配岗位",
  "Bot促活推送.策略名称": "策略名称",
  "Bot促活推送.策略类型": "触达类型",
  "Bot促活推送.薪资取整": "薪资取整单位",
  "Bot促活推送.薪资文案": "薪资附加文案",
  "Bot促活推送.薪资文案说明": "可留空；填写时必须包含 {salary}。仅有有效薪资时追加。",
  "Bot促活推送.薪资算法": "薪资算法",
  "Bot促活推送.薪资算法.none": "不计算薪资",
  "Bot促活推送.薪资算法.p80_midpoint": "岗位薪资中值 P80",
  "Bot促活推送.记录ID": "记录 ID",
  "Bot促活推送.语言.en_US": "English",
  "Bot促活推送.语言.km_KH": "ភាសាខ្មែរ",
  "Bot促活推送.语言.zh_CN": "中文",
  "Bot促活推送.运行配置": "运行配置",
  "Bot促活推送.页面标题": "Bot促活推送",
  "Bot促活推送.页面说明": "管理岗位/简历联系 Bot 的定时促活。保存后约 20 秒内生效，时间均为北京时间。",
  "Bot促活推送.频控说明": "现有频控继续生效：回 App 促活同一用户每天最多 1 条、滚动 7 天最多 2 条；频道导流按 7 天间隔，连续忽略后为 14 天。",
  "menu.account": "个人页",
  "menu.account.logout": "退出登录",
  "menu.account.settings": "个人设置",
  "menu.ad-channels": "推广渠道管理",
  "menu.commercial": "商业化管理",
  "menu.commercial.commercial-benefits": "权益配置",
  "menu.commercial.commercial-orders": "订单管理",
  "menu.commercial.commercial-paywalls": "页面配置",
  "menu.commercial.commercial-products": "商品管理",
  "menu.companies": "企业管理",
  "menu.companies.companies-config": "配置管理",
  "menu.companies.companies-list": "企业管理",
  "menu.config": "配置管理",
  "menu.config.benefit-guarantee-tags": "标签词库",
  "menu.config.employer-sales-contacts": "销售联系方式",
  "menu.config.hot-job-groups": "热门分组配置",
  "menu.config.hot-search-words": "热搜词配置",
  "menu.config.jd-complaint-types": "岗位投诉类型",
  "menu.config.jd-feedback-types": "岗位反馈类型",
  "menu.config.job-groups": "岗位分组配置",
  "menu.config.job-positions": "岗位标签",
  "menu.config.job-relations": "关联工种配置",
  "menu.config.locations": "地区管理",
  "menu.config.visitor-contact-limit": "游客联系限制",
  "menu.content": "内容管理",
  "menu.content.content-articles": "资讯发布",
  "menu.content.content-media-partners": "合作媒体",
  "menu.facebook": "Facebook矩阵",
  "menu.facebook.facebook-entities": "数据源配置",
  "menu.feedback": "反馈与投诉",
  "menu.feedback.account-appeals-list": "账号申诉列表",
  "menu.feedback.feedback-list": "意见反馈列表",
  "menu.feedback.im-presets": "IM常用语",
  "menu.feedback.jd-feedback-records-list": "岗位反馈记录",
  "menu.feedback.job-complaints-list": "岗位投诉列表",
  "menu.feedback.job-taxonomy-search-feedbacks": "工种搜索反馈",
  "menu.feedback.match-feedback": "IM匹配反馈",
  "menu.feedback.resume-complaints-list": "简历投诉列表",
  "menu.home": "首页",
  "menu.job-seekers": "求职用户",
  "menu.job-seekers.job-seekers-job-intention-detail": "求职意向详情",
  "menu.job-seekers.job-seekers-job-intentions": "求职意向",
  "menu.job-seekers.job-seekers-resume-detail": "简历详情",
  "menu.job-seekers.job-seekers-resume-source-files": "简历附件审核",
  "menu.job-seekers.job-seekers-resumes": "简历管理",
  "menu.job-seekers.job-seekers-user-detail": "用户详情",
  "menu.job-seekers.job-seekers-users": "用户管理",
  "menu.jobs": "岗位管理",
  "menu.jobs.jobs-blacklist": "岗位黑名单",
  "menu.jobs.jobs-generation": "岗位生成",
  "menu.jobs.jobs-generation-dashboard": "岗位数据看板",
  "menu.jobs.jobs-list": "岗位管理",
  "menu.jobs.jobs-review-records": "审核记录",
  "menu.login": "登录",
  "menu.staff": "员工管理",
  "menu.staff.staff-detail": "员工详情",
  "menu.staff.staff-list": "员工列表",
  "menu.staff.staff-operation-logs": "操作记录",
  "menu.staff.staff-roles-permissions": "角色和权限",
  "menu.telegram": "Telegram矩阵",
  "menu.telegram.telegram-accounts": "账号管理",
  "menu.telegram.telegram-dashboard": "Dashboard",
  "menu.telegram.telegram-entities": "会话管理",
  "menu.test": "测试页面",
  "menu.test.google-map": "Google 地图测试",
  "menu.tools": "运营工具",
  "menu.tools.bot-activation-push": "Bot促活推送",
  "menu.tools.facebook-reauth-push": "Facebook 推送测试",
  "menu.tools.home-marquee-banners": "首页跑马灯 Banner",
  "menu.tools.home-shortcuts": "首页金刚位",
  "menu.tools.marketing-push": "营销推送",
  "menu.tools.mobile-push": "移动推送测试",
  "menu.tools.telegram-push": "Bot 促活测试",
  "menu.welcome": "欢迎",
  "navBar.lang": "语言",
  "匹配反馈.ignored": "已忽略",
  "匹配反馈.pending": "待处理",
  "匹配反馈.processed": "已处理",
  "匹配反馈.会话": "会话",
  "匹配反馈.保存": "保存",
  "匹配反馈.候选人": "候选人",
  "匹配反馈.允许补充说明": "允许补充说明",
  "匹配反馈.原因": "原因",
  "匹配反馈.原因配置": "原因配置",
  "匹配反馈.发起人": "发起人",
  "匹配反馈.否": "否",
  "匹配反馈.启用": "启用",
  "匹配反馈.处理状态": "处理状态",
  "匹配反馈.岗位": "岗位",
  "匹配反馈.已保存": "已保存",
  "匹配反馈.已取消": "已取消",
  "匹配反馈.招聘者": "招聘者",
  "匹配反馈.排序": "排序",
  "匹配反馈.操作": "操作",
  "匹配反馈.新增": "新增",
  "匹配反馈.时间": "时间",
  "匹配反馈.是": "是",
  "匹配反馈.标题": "IM匹配反馈",
  "匹配反馈.求职者": "求职者",
  "匹配反馈.生效": "生效",
  "匹配反馈.编码": "编码",
  "匹配反馈.编辑": "编辑",
  "匹配反馈.补充说明": "补充说明",
  "匹配反馈.记录": "记录",
  "匹配反馈.详情": "详情",
  "匹配反馈.说明限制": "每个身份仅启用一个补充说明项，用户可选填500字。停用不会删除历史记录。",
  "匹配反馈.身份": "身份",
  "匹配反馈.运营备注": "运营备注",
  "布局.用户.帮助": "帮助",
  "布局.用户.条款": "条款",
  "布局.用户.隐私": "隐私",
  "布局.页脚.版权": "2026 dodojob 运营管理后台",
  "常用语.availability": "沟通时间",
  "常用语.decline": "礼貌拒绝",
  "常用语.first_contact": "初次沟通",
  "常用语.follow_up": "继续跟进",
  "常用语.interview": "面试安排",
  "常用语.resume": "简历相关",
  "常用语.保存发布": "保存并发布",
  "常用语.内容": "内容",
  "常用语.场景": "场景",
  "常用语.标题": "IM常用语",
  "常用语.长度限制": "最多200字",
  "应用.PWA.刷新": "刷新",
  "应用.PWA.刷新提示": "请点击“刷新”按钮或者手动刷新页面",
  "应用.PWA.有新内容": "有新内容",
  "应用.PWA.离线": "当前处于离线状态",
  "组件.地区与字典.一级": "一级",
  "组件.地区与字典.三级": "三级",
  "组件.地区与字典.二级": "二级",
  "组件.地区与字典.地区不存在显示原始code": "地区不存在，显示原始 code: {code}",
  "组件.地区与字典.字典项不存在显示原始id": "字典项不存在，显示原始 id: {id}",
  "组件.地区与字典.当前": "（当前）",
  "组件.地区与字典.暂无多语言": "暂无多语言",
  "组件.地区与字典.第N级": "第{n}级",
  "组件.地址.关闭": "关闭",
  "组件.地址.加载地图中": "加载地图中...",
  "组件.地址.在地图中查看地址": "在地图中查看地址",
  "组件.地址.在地图中编辑地址": "在地图中编辑地址",
  "组件.地址.在地图中选择地址": "在地图中选择地址",
  "组件.地址.地区": "地区",
  "组件.地址.地图显示": "地图显示",
  "组件.地址.地址预览": "地址预览",
  "组件.地址.地点已选择": "地点已选择",
  "组件.地址.地点选择": "地点选择",
  "组件.地址.当前地址": "当前地址：",
  "组件.地址.搜索地址": "搜索地址",
  "组件.地址.未找到地址": "未找到匹配地址",
  "组件.地址.未配置GoogleMapsAPIKey": "未配置 Google Maps API Key，请在环境配置文件中设置 GOOGLE_MAPS_API_KEY",
  "组件.地址.标准地址": "标准地址：",
  "组件.地址.生成地图图片": "生成地图图片",
  "组件.地址.详细地址": "详细地址",
  "组件.地址.语言": "语言",
  "组件.地址.请先选择地点": "请先选择地点",
  "组件.地址.请输入地点名称或地址": "请输入地点名称或地址",
  "组件.地址.请输入详细地址如3楼301室": "请输入详细地址，如：3楼301室",
  "组件.地址.预览图生成中": "地图预览图生成中，请稍后提交",
  "组件.地址.预览图生成失败": "地图预览图生成失败，请重新选择地点后再试",
  "组件.地址.预览图生成成功": "地图图片已生成",
  "组件.标签选择.全部": "全部",
  "组件.标签选择.展开": "展开",
  "组件.标签选择.收起": "收起",
  "组件.顶栏.使用文档": "使用文档",
  "组件.顶栏.站内搜索": "站内搜索",
  "组件.顶栏.通知": "通知",
  "菜单.Facebook矩阵": "Facebook矩阵",
  "菜单.Facebook矩阵.数据源配置": "数据源配置",
  "菜单.Telegram矩阵": "Telegram矩阵",
  "菜单.Telegram矩阵.Dashboard": "Dashboard",
  "菜单.Telegram矩阵.会话管理": "会话管理",
  "菜单.Telegram矩阵.账号管理": "账号管理",
  "菜单.个人页": "个人页",
  "菜单.个人页.个人设置": "个人设置",
  "菜单.企业管理": "企业管理",
  "菜单.企业管理.企业管理": "企业管理",
  "菜单.企业管理.配置管理": "配置管理",
  "菜单.内容管理": "内容管理",
  "菜单.内容管理.合作媒体": "合作媒体",
  "菜单.内容管理.资讯发布": "资讯发布",
  "菜单.反馈与投诉": "反馈与投诉",
  "菜单.反馈与投诉.岗位反馈记录": "岗位反馈记录",
  "菜单.反馈与投诉.岗位投诉列表": "岗位投诉列表",
  "菜单.反馈与投诉.工种搜索反馈": "工种搜索反馈",
  "菜单.反馈与投诉.意见反馈列表": "意见反馈列表",
  "菜单.反馈与投诉.简历投诉列表": "简历投诉列表",
  "菜单.反馈与投诉.账号申诉列表": "账号申诉列表",
  "菜单.员工管理": "员工管理",
  "菜单.员工管理.员工列表": "员工列表",
  "菜单.员工管理.员工详情": "员工详情",
  "菜单.员工管理.操作记录": "操作记录",
  "菜单.员工管理.角色和权限": "角色和权限",
  "菜单.商业化管理": "商业化管理",
  "菜单.商业化管理.商品管理": "商品管理",
  "菜单.商业化管理.权益配置": "权益配置",
  "菜单.商业化管理.订单管理": "订单管理",
  "菜单.商业化管理.页面配置": "页面配置",
  "菜单.岗位管理": "岗位管理",
  "菜单.岗位管理.审核记录": "审核记录",
  "菜单.岗位管理.岗位生成": "岗位生成",
  "菜单.岗位管理.岗位生成数据看板": "岗位数据看板",
  "菜单.岗位管理.岗位管理": "岗位管理",
  "菜单.岗位管理.岗位黑名单": "岗位黑名单",
  "菜单.推广渠道管理": "推广渠道管理",
  "菜单.欢迎": "欢迎",
  "菜单.求职用户": "求职用户",
  "菜单.求职用户.求职意向": "求职意向",
  "菜单.求职用户.求职意向详情": "求职意向详情",
  "菜单.求职用户.用户管理": "用户管理",
  "菜单.求职用户.用户详情": "用户详情",
  "菜单.求职用户.简历管理": "简历管理",
  "菜单.求职用户.简历详情": "简历详情",
  "菜单.求职用户.简历附件审核": "简历附件审核",
  "菜单.测试页面": "测试页面",
  "菜单.测试页面.Google地图测试": "Google 地图测试",
  "菜单.登录": "登录",
  "菜单.运营工具": "运营工具",
  "菜单.运营工具.Bot促活推送": "Bot促活推送",
  "菜单.运营工具.Bot促活测试": "Bot 促活测试",
  "菜单.运营工具.Facebook重新授权推送测试": "Facebook 推送测试",
  "菜单.运营工具.移动推送测试": "移动推送测试",
  "菜单.运营工具.营销推送": "营销推送",
  "菜单.运营工具.首页跑马灯": "首页跑马灯 Banner",
  "菜单.运营工具.首页金刚位": "首页金刚位",
  "菜单.退出登录": "退出登录",
  "菜单.配置管理": "配置管理",
  "菜单.配置管理.关联工种配置": "关联工种配置",
  "菜单.配置管理.地区管理": "地区管理",
  "菜单.配置管理.岗位分组配置": "岗位分组配置",
  "菜单.配置管理.岗位反馈类型": "岗位反馈类型",
  "菜单.配置管理.岗位投诉类型": "岗位投诉类型",
  "菜单.配置管理.岗位标签": "岗位标签",
  "菜单.配置管理.游客联系限制": "游客联系限制",
  "菜单.配置管理.热搜词配置": "热搜词配置",
  "菜单.配置管理.热门分组配置": "热门分组配置",
  "菜单.配置管理.福利与保障标签": "标签词库",
  "菜单.配置管理.销售联系方式": "销售联系方式",
  "菜单.首页": "首页",
  "营销推送.Bot媒体": "Bot 图片/视频",
  "营销推送.Bot按钮": "Bot 按钮",
  "营销推送.Bot按钮文字": "按钮文字",
  "营销推送.Bot按钮类型": "按钮类型",
  "营销推送.Bot按钮类型.app_page": "返回 App 页面",
  "营销推送.Bot按钮类型.channel": "Telegram 频道",
  "营销推送.Bot按钮类型.mini_app": "Telegram Mini App",
  "营销推送.Bot按钮说明": "最多 3 个，按顺序每行显示一个。按钮文字跟随语言切换。",
  "营销推送.Bot按钮链接": "Telegram 链接",
  "营销推送.Bot按钮页面": "App 页面",
  "营销推送.Bot正文": "Bot 正文",
  "营销推送.Bot消息类型": "Bot 消息类型",
  "营销推送.Bot消息类型.image": "图片＋文字",
  "营销推送.Bot消息类型.text": "纯文字",
  "营销推送.Bot消息类型.video": "视频＋文字",
  "营销推送.broadcast": "通用营销",
  "营销推送.generic_jobs": "无画像岗位推荐",
  "营销推送.location_jobs": "按区域推荐岗位",
  "营销推送.matched_jobs": "工种＋区域岗位推荐",
  "营销推送.position_jobs": "按工种推荐岗位",
  "营销推送.resume_incomplete": "提醒完善简历",
  "营销推送.resume_missing": "提醒填写简历",
  "营销推送.下次发送": "下次计划时间",
  "营销推送.人群": "目标人群",
  "营销推送.仅限HTTPS": "请输入完整的 HTTPS 链接",
  "营销推送.保存为暂停": "保存为暂停",
  "营销推送.保存生效": "保存生效",
  "营销推送.全部用户": "全部 App 用户（登录用户＋游客）",
  "营销推送.全部用户说明": "覆盖有有效推送设备的登录用户和游客。请先预览、试发并确认文案，再启用。",
  "营销推送.删除": "删除",
  "营销推送.刷新": "刷新",
  "营销推送.加载岗位失败": "加载岗位失败",
  "营销推送.区域": "模拟区域",
  "营销推送.历史文案未保存": "历史记录未保存消息内容",
  "营销推送.历史记录": "历史记录",
  "营销推送.历史记录说明": "旧记录未标记发送环境，只在线上后台展示。",
  "营销推送.参数.apply_job_id": "应聘岗位 ID（选填）",
  "营销推送.参数.benefit_tags": "福利标签代码（多个用英文逗号分隔）",
  "营销推送.参数.category_id": "岗位分类代码",
  "营销推送.参数.company_id": "公司 ID",
  "营销推送.参数.job_category_code": "工种代码（选填）",
  "营销推送.参数.job_id": "岗位 ID",
  "营销推送.参数.job_position_tags": "工种代码（多个用英文逗号分隔）",
  "营销推送.参数.keyword": "搜索词",
  "营销推送.参数.locations": "地区代码（多个用英文逗号分隔）",
  "营销推送.参数.source_job_id": "来源岗位 ID（选填）",
  "营销推送.参数.title": "网页标题（选填）",
  "营销推送.参数.url": "网页链接",
  "营销推送.发送失败": "发送失败",
  "营销推送.发送成功": "发送成功",
  "营销推送.发送日期": "发送日期",
  "营销推送.发送时间": "发送时间（北京时间）",
  "营销推送.发送测试": "发送给测试账号",
  "营销推送.发送类型": "发送类型",
  "营销推送.发送结果": "发送结果",
  "营销推送.发送记录": "发送记录",
  "营销推送.发送记录说明": "按设备记录发送结果，重试合并显示。成功表示推送服务已接受，不代表用户已查看。",
  "营销推送.变量说明": "支持 '{count}' 岗位数、'{position}' 工种、'{location}' 区域、'{salary}' 薪资；只能使用该人群已有的数据。每种语言至少保留一套不含薪资的模板。多套模板按星期轮换。",
  "营销推送.后台试发": "后台试发",
  "营销推送.启用": "启用",
  "营销推送.固定文案说明": "全量营销使用固定文案，不支持个人工种、地区或薪资变量。",
  "营销推送.处理中": "处理中",
  "营销推送.失败原因": "失败原因",
  "营销推送.定时发送": "定时发送",
  "营销推送.尝试次数": "尝试次数",
  "营销推送.岗位数量": "岗位数量",
  "营销推送.工种": "模拟工种",
  "营销推送.已保存": "已保存，新配置将自动生效",
  "营销推送.已跳过": "已跳过",
  "营销推送.当前绑定": "设备当前账号",
  "营销推送.当前绑定说明": "旧记录未保存发送时账号，此处为设备当前绑定账号，可能与当时不同。",
  "营销推送.总开关关闭": "当前环境自动营销推送未开启。可以保存配置和试发，定时任务不会发送。",
  "营销推送.执行星期": "执行星期",
  "营销推送.按原策略跳转": "按原策略跳转",
  "营销推送.按现有策略": "按现有策略筛选",
  "营销推送.接收用户": "接收用户",
  "营销推送.搜索岗位": "搜索岗位名称或编号",
  "营销推送.操作": "操作",
  "营销推送.操作失败": "操作失败，请检查输入；若配置已更新，请关闭后刷新再试。",
  "营销推送.新增说明": "保存前可预览并向指定账号试发。保存后默认为暂停，在列表启用后才会定时发送。",
  "营销推送.时间范围": "请选择 08:00–20:59",
  "营销推送.时间说明": "北京时间 08:00–20:59。保存后 30 秒内读取新配置；同一计划每天最多发送一次，不补发已错过的时段。",
  "营销推送.星期0": "周一",
  "营销推送.星期1": "周二",
  "营销推送.星期2": "周三",
  "营销推送.星期3": "周四",
  "营销推送.星期4": "周五",
  "营销推送.星期5": "周六",
  "营销推送.星期6": "周日",
  "营销推送.标题": "标题",
  "营销推送.模板": "模板",
  "营销推送.模板序号": "模板序号",
  "营销推送.模板数量": "模板数",
  "营销推送.正文": "正文",
  "营销推送.测试账号": "测试用户 ID",
  "营销推送.添加Bot按钮": "添加 Bot 按钮",
  "营销推送.添加模板": "添加模板",
  "营销推送.添加营销推送": "添加营销推送",
  "营销推送.游客": "游客",
  "营销推送.登录用户": "登录用户",
  "营销推送.策略配置": "策略配置",
  "营销推送.编辑": "编辑",
  "营销推送.联系Bot说明": "点击通知后进入岗位/简历联系 Bot（非登录 Bot）。每次修改内容会生成新链接，已发送的旧链接仍保留当时内容。",
  "营销推送.落地页.company_homepage": "公司主页",
  "营销推送.落地页.external_web": "外部浏览器",
  "营销推送.落地页.internal_web": "App 内网页",
  "营销推送.落地页.job_category": "岗位分类",
  "营销推送.落地页.job_detail": "岗位详情",
  "营销推送.落地页.job_search": "岗位搜索",
  "营销推送.落地页.jobs_home": "岗位首页",
  "营销推送.落地页.profile_home": "我的",
  "营销推送.落地页.resume_card_form": "填写简历",
  "营销推送.落地页.resume_manage": "简历管理",
  "营销推送.落地页.talent_pool_home": "人才库",
  "营销推送.落地页.telegram_contact_bot": "Bot 推送",
  "营销推送.薪资": "月薪（美元）",
  "营销推送.计划": "计划",
  "营销推送.计划列表": "推送计划",
  "营销推送.计划名称": "计划名称",
  "营销推送.记录ID": "记录 ID",
  "营销推送.设备ID": "设备 ID",
  "营销推送.设备平台": "设备平台",
  "营销推送.试发结果": "设备 {total} 台，平台接受 {success} 台，失败 {failed} 台；请在测试设备确认收到。",
  "营销推送.语言": "语言",
  "营销推送.请上传Bot媒体": "请上传图片或视频",
  "营销推送.跳转目标": "跳转目标",
  "营销推送.跳转说明": "点击通知后打开所选页面。切换目标后，请重新填写页面参数。",
  "营销推送.身份未知": "身份未记录",
  "营销推送.选择工种": "选择工种",
  "营销推送.页面标题": "App 营销推送",
  "营销推送.页面说明": "配置 App 营销消息的模板、时间和跳转页面。",
  "营销推送.预览": "预览",
  "营销推送.预览与试发": "预览与试发",
  "营销推送.默认跳转说明": "岗位推荐按用户工种进入岗位首页，简历提醒进入填写简历页；预览仅展示默认页面。",
  "设置.基本信息.昵称": "昵称",
  "设置.菜单.基本设置": "基本设置",
  "设置抽屉.主题色": "主题色",
  "设置抽屉.整体风格": "整体风格设置",
  "通用.上传中": "上传中…",
  "通用.上传失败": "上传失败",
  "通用.上传成功": "上传成功",
  "通用.中文": "中文",
  "通用.保存": "保存",
  "通用.保存失败": "保存失败",
  "通用.保存失败重试": "保存失败，请重试",
  "通用.保存成功": "保存成功",
  "通用.停用": "停用",
  "通用.创建失败": "创建失败",
  "通用.创建失败重试": "创建失败，请重试",
  "通用.创建成功": "创建成功",
  "通用.删除": "删除",
  "通用.删除失败": "删除失败",
  "通用.删除失败重试": "删除失败，请重试",
  "通用.删除成功": "删除成功",
  "通用.加载中": "加载中...",
  "通用.取消": "取消",
  "通用.同步失败": "同步失败",
  "通用.同步失败重试": "同步失败，请重试",
  "通用.同步成功": "同步成功",
  "通用.名称": "名称",
  "通用.名称不能为空": "名称不能为空",
  "通用.启用": "启用",
  "通用.备注": "备注",
  "通用.导出": "导出",
  "通用.导出失败": "导出失败，请重试",
  "通用.导出成功": "导出成功",
  "通用.展开": "展开",
  "通用.批量删除": "批量删除",
  "通用.操作": "操作",
  "通用.收起": "收起",
  "通用.新建": "新建",
  "通用.暂无可导出数据": "暂无可导出数据",
  "通用.更换图片": "更换图片",
  "通用.更新失败": "更新失败",
  "通用.更新失败重试": "更新失败，请重试",
  "通用.更新成功": "更新成功",
  "通用.查询": "查询",
  "通用.添加失败": "添加失败",
  "通用.添加失败重试": "添加失败，请重试！",
  "通用.添加成功": "添加成功",
  "通用.状态": "状态",
  "通用.确定": "确定",
  "通用.禁用": "禁用",
  "通用.系统": "系统",
  "通用.编辑": "编辑",
  "通用.英文": "英文",
  "通用.请输入": "请输入",
  "通用.请输入备注": "请输入备注（可选）",
  "通用.请选择": "请选择",
  "通用.选择图片": "选择图片",
  "通用.重置": "重置",
  "通用.重置失败": "重置失败",
  "通用.重置成功": "重置成功",
  "通用.重试": "重试",
  "通用.高棉语": "高棉语",
  "错误.登录已过期": "登录已过期，请重新登录",
  "错误.网络错误": "网络错误，请检查网络连接",
  "错误.请求失败": "请求失败",
  "错误.请求错误": "请求错误，请重试",
  "页面.403.无权限": "您没有权限访问该页面。",
  "页面.403.返回首页": "返回首页",
  "页面.404.抱歉": "抱歉，您访问的页面不存在。",
  "页面.404.返回首页": "返回首页",
  "页面.Bot测试.ID格式": "填写有效的 Telegram 数字 ID",
  "页面.Bot测试.TGID": "Telegram 用户 ID",
  "页面.Bot测试.兜底": "导流频道 · 无画像",
  "页面.Bot测试.分组": "文案分组",
  "页面.Bot测试.分组.A": "A · 带区域",
  "页面.Bot测试.分组.auto": "自动分组",
  "页面.Bot测试.分组.B": "B · 不带区域",
  "页面.Bot测试.参数": "测试设置",
  "页面.Bot测试.发送": "发送测试",
  "页面.Bot测试.发送未知": "未确认发送结果，请先检查 Telegram，避免重复发送。",
  "页面.Bot测试.场景": "推荐场景",
  "页面.Bot测试.场景.generic_jobs": "返回 App · 无画像",
  "页面.Bot测试.场景.im": "IM 未读提醒",
  "页面.Bot测试.场景.jd_contact": "岗位联系卡片（模拟）",
  "页面.Bot测试.场景.location_jobs": "返回 App · 仅地区",
  "页面.Bot测试.场景.matched_jobs": "返回 App · 工种和地区",
  "页面.Bot测试.场景.onboarding": "首次进入欢迎语",
  "页面.Bot测试.场景.position_jobs": "返回 App · 仅工种",
  "页面.Bot测试.场景.reply": "用户主动消息回复",
  "页面.Bot测试.场景.resume_contact": "简历联系卡片（模拟）",
  "页面.Bot测试.填写工种": "填写工种名称",
  "页面.Bot测试.填写接收人": "填写接收人 ID",
  "页面.Bot测试.就绪": "已就绪",
  "页面.Bot测试.岗位": "导流频道 · 有画像",
  "页面.Bot测试.岗位数": "模拟岗位数量",
  "页面.Bot测试.工种": "工种名称",
  "页面.Bot测试.工种编码": "App 工种编码（可选）",
  "页面.Bot测试.平台ID": "平台用户 ID",
  "页面.Bot测试.接收人": "接收人",
  "页面.Bot测试.接收身份": "接收身份",
  "页面.Bot测试.未就绪": "未就绪",
  "页面.Bot测试.标题": "Bot 促活测试",
  "页面.Bot测试.模式": "测试方式",
  "页面.Bot测试.模拟": "指定参数试发",
  "页面.Bot测试.模拟地区": "模拟地区",
  "页面.Bot测试.模拟姓名": "模拟姓名",
  "页面.Bot测试.模拟描述": "消息摘要 / 岗位要求 / 技能",
  "页面.Bot测试.模拟说明": "使用模拟参数发送真实消息，不占正式促活额度。接收人须已启动此 Bot。",
  "页面.Bot测试.求职者": "求职者",
  "页面.Bot测试.状态.activation_disabled": "正式促活未开启，可切换指定参数试发",
  "页面.Bot测试.状态.already_in_channel": "用户已加入频道",
  "页面.Bot测试.状态.ambiguous_user": "关联多个账号，请填写 Telegram 用户 ID",
  "页面.Bot测试.状态.app_url_missing": "未配置有效的 App 返回地址",
  "页面.Bot测试.状态.bot_unavailable": "当前 Bot 未就绪",
  "页面.Bot测试.状态.channel_membership_unknown": "频道成员状态不可查，请先将 Bot 加为频道管理员",
  "页面.Bot测试.状态.channel_missing": "尚未配置目标频道",
  "页面.Bot测试.状态.duplicate": "本次测试已处理，请勿重复发送",
  "页面.Bot测试.状态.failed": "发送失败或结果未知，请检查 Telegram 和服务日志",
  "页面.Bot测试.状态.frequency_limited": "今日已发送促活消息",
  "页面.Bot测试.状态.insufficient_jobs": "岗位数量低于推送门槛",
  "页面.Bot测试.状态.no_candidate": "未匹配：检查求职身份、画像、场景或当日岗位数",
  "页面.Bot测试.状态.rate_limited": "发送过于频繁，请稍后重新预览",
  "页面.Bot测试.状态.ready": "可以发送",
  "页面.Bot测试.状态.recent_campaign": "近期已被其他活动触达",
  "页面.Bot测试.状态.sent": "已提交至 Telegram",
  "页面.Bot测试.状态.tracking_missing": "尚未配置点击追踪地址",
  "页面.Bot测试.状态.unreachable": "用户未启动此 Bot，或已停用会话",
  "页面.Bot测试.状态.unsubscribed": "用户已关闭岗位提醒",
  "页面.Bot测试.状态.user_not_found": "未找到关联的 Telegram 用户",
  "页面.Bot测试.真实": "按真实规则",
  "页面.Bot测试.真实说明": "按真实画像和当日岗位匹配；发送后占用今日促活额度。",
  "页面.Bot测试.空预览": "填写接收人，预览消息和发送条件",
  "页面.Bot测试.触发测试说明": "仅试发已有消息模板，不触发真实 IM 或简历授权。联系卡片使用模拟资料，按钮指向测试接收人；岗位卡片按文本预览。",
  "页面.Bot测试.语言": "消息语言",
  "页面.Bot测试.请求失败": "加载失败，请重试",
  "页面.Bot测试.连接": "Bot 状态",
  "页面.Bot测试.重试": "重试",
  "页面.Bot测试.门槛": "最低岗位数",
  "页面.Bot测试.雇主": "雇主",
  "页面.Bot测试.预览": "预览消息",
  "页面.Facebook推送测试.页面标题": "Facebook 推送测试",
  "页面.Facebook推送测试.页面说明": "按用户 ID 测试 Facebook 重新授权；运营测试不限制 Facebook App ID，且始终只发送到最新有效设备。",
  "页面.Facebook矩阵.数据源配置.分类": "分类",
  "页面.Facebook矩阵.数据源配置.分类名称": "分类名称",
  "页面.Facebook矩阵.数据源配置.分类名称占位": "输入分类名称，如：招聘群组",
  "页面.Facebook矩阵.数据源配置.分类名称必填": "请输入分类名称",
  "页面.Facebook矩阵.数据源配置.创建时间": "创建时间",
  "页面.Facebook矩阵.数据源配置.名称": "名称",
  "页面.Facebook矩阵.数据源配置.名称必填": "请输入名称",
  "页面.Facebook矩阵.数据源配置.名称说明": "运营侧管理用名称",
  "页面.Facebook矩阵.数据源配置.备注": "备注",
  "页面.Facebook矩阵.数据源配置.备注占位": "可选备注说明",
  "页面.Facebook矩阵.数据源配置.外部实体ID": "外部实体 ID",
  "页面.Facebook矩阵.数据源配置.外部实体ID占位": "可选，外部服务中的实体 ID",
  "页面.Facebook矩阵.数据源配置.实体类型": "实体类型",
  "页面.Facebook矩阵.数据源配置.实体类型主页": "主页",
  "页面.Facebook矩阵.数据源配置.实体类型帖子": "帖子",
  "页面.Facebook矩阵.数据源配置.实体类型群组": "群组",
  "页面.Facebook矩阵.数据源配置.实体类型频道": "频道",
  "页面.Facebook矩阵.数据源配置.实体链接": "实体链接",
  "页面.Facebook矩阵.数据源配置.实体链接必填": "请输入实体链接",
  "页面.Facebook矩阵.数据源配置.实体链接说明": "Facebook permalink（可访问链接）",
  "页面.Facebook矩阵.数据源配置.成功删除N个": "成功删除 {n} 条",
  "页面.Facebook矩阵.数据源配置.成功删除部分失败": "成功 {ok} 条，失败 {fail} 条",
  "页面.Facebook矩阵.数据源配置.按分类查看": "数据源（按分类）",
  "页面.Facebook矩阵.数据源配置.按实体类型查看": "数据源（按实体类型）",
  "页面.Facebook矩阵.数据源配置.数据源数": "数据源数",
  "页面.Facebook矩阵.数据源配置.新建分类": "新建分类",
  "页面.Facebook矩阵.数据源配置.新建数据源": "新建数据源",
  "页面.Facebook矩阵.数据源配置.更新时间": "更新时间",
  "页面.Facebook矩阵.数据源配置.未分类": "未分类",
  "页面.Facebook矩阵.数据源配置.标题": "FB 抓取数据源配置",
  "页面.Facebook矩阵.数据源配置.正在删除N个": "正在删除 {n} 条...",
  "页面.Facebook矩阵.数据源配置.正在更新": "正在更新...",
  "页面.Facebook矩阵.数据源配置.正在添加": "正在添加...",
  "页面.Facebook矩阵.数据源配置.状态已拒绝": "已拒绝",
  "页面.Facebook矩阵.数据源配置.状态待审核": "待审核",
  "页面.Facebook矩阵.数据源配置.确定删除": "确定要删除这条数据源吗？",
  "页面.Facebook矩阵.数据源配置.确定删除分类": "确定要删除该分类吗？其下数据源将变为未分类",
  "页面.Facebook矩阵.数据源配置.管理分类": "管理分类",
  "页面.Facebook矩阵.数据源配置.编辑分类": "编辑分类",
  "页面.Facebook矩阵.数据源配置.编辑数据源": "编辑数据源",
  "页面.Facebook矩阵.数据源配置.选择分类": "请选择分类",
  "页面.Telegram矩阵.ClientKey创建": "Client Key 创建",
  "页面.Telegram矩阵.云端托管": "云端托管",
  "页面.Telegram矩阵.创建方式": "创建方式",
  "页面.Telegram矩阵.客户端上报": "客户端上报",
  "页面.Telegram矩阵.扫码授权云端托管": "扫码授权（云端托管）",
  "页面.Telegram矩阵.新增授权账号": "新增授权账号",
  "页面.Telegram矩阵.账号类型": "账号类型",
  "页面.Telegram矩阵.通过ClientKey创建客户端上报": "通过 Client Key 创建（客户端上报）",
  "页面.企业.Logo": "Logo",
  "页面.企业.Logo说明": "企业Logo",
  "页面.企业.Telegram用户ID": "Telegram用户ID",
  "页面.企业.Telegram用户名": "Telegram用户名",
  "页面.企业.上传Logo": "上传Logo",
  "页面.企业.上传媒体": "上传媒体",
  "页面.企业.上传认证材料": "上传认证材料",
  "页面.企业.代发岗位": "代发岗位",
  "页面.企业.企业ID": "企业ID",
  "页面.企业.企业ID点击详情": "企业ID，点击查看详情",
  "页面.企业.企业Logo": "企业Logo",
  "页面.企业.企业Logoextra": "支持JPG/PNG格式，单个文件不超过5MB",
  "页面.企业.企业Logotooltip": "支持裁剪1:1比例，若未上传显示首字母默认图",
  "页面.企业.企业信息": "企业信息",
  "页面.企业.企业全称": "企业全称",
  "页面.企业.企业全称说明": "企业全称（唯一标识）",
  "页面.企业.企业全称长度2到50": "企业全称长度为2-50个字符",
  "页面.企业.企业简称": "企业简称",
  "页面.企业.企业简称不能超过20": "企业简称不能超过20个字符",
  "页面.企业.企业管理": "企业管理",
  "页面.企业.企业规模": "企业规模",
  "页面.企业.企业详情": "企业详情",
  "页面.企业.信任背书": "信任背书",
  "页面.企业.修改者": "修改者",
  "页面.企业.公司地址": "公司地址",
  "页面.企业.公司地址tooltip": "支持地图选择或手动填写",
  "页面.企业.公司环境媒体": "公司环境媒体",
  "页面.企业.公司环境媒体extra": "支持图片（JPG/PNG）和视频（MP4/MOV），单个文件不超过50MB",
  "页面.企业.公司环境媒体tooltip": "最多9个文件（图片或视频），前端自行判断是图片还是视频",
  "页面.企业.公司简介": "公司简介",
  "页面.企业.公司简介placeholder": "支持AI润色功能",
  "页面.企业.关键词搜索": "关键词搜索",
  "页面.企业.关键词搜索说明": "搜索企业全称、简称等（后端自动匹配多个字段）",
  "页面.企业.创建失败": "创建失败",
  "页面.企业.创建失败请重试": "创建失败，请重试",
  "页面.企业.创建成功": "创建成功",
  "页面.企业.创建时间": "创建时间",
  "页面.企业.创建时间说明": "创建时间，hover 显示原始值",
  "页面.企业.删除": "删除",
  "页面.企业.删除后可以恢复": "删除后可以恢复，但数据将不再显示在列表中。",
  "页面.企业.删除失败请重试": "删除失败，请重试",
  "页面.企业.发布岗位数量": "发布岗位数量",
  "页面.企业.取消": "取消",
  "页面.企业.在招岗位": "在招岗位",
  "页面.企业.基础信息": "基础信息",
  "页面.企业.备注": "备注",
  "页面.企业.备注placeholder": "仅运营团队内部可见，用于记录审核细节",
  "页面.企业.备注不能超过500": "备注不能超过500个字符",
  "页面.企业.已认证": "已认证",
  "页面.企业.成功删除N个企业": "成功删除 {count} 个企业",
  "页面.企业.成功删除N个失败M个": "成功删除 {success} 个，失败 {fail} 个",
  "页面.企业.所属行业": "所属行业",
  "页面.企业.手动填写地址": "手动填写地址：",
  "页面.企业.手动填写非标地址": "手动填写非标地址",
  "页面.企业.批量删除": "批量删除",
  "页面.企业.提交": "提交",
  "页面.企业.提交失败请重试": "提交失败，请重试",
  "页面.企业.操作": "操作",
  "页面.企业.支持国际区号格式": "支持国际区号格式，如：+855",
  "页面.企业.收起手动填写": "收起手动填写",
  "页面.企业.新建企业": "新建企业",
  "页面.企业.无Logo": "无 Logo",
  "页面.企业.时间信息": "时间信息",
  "页面.企业.是否有Logo": "是否有企业 Logo",
  "页面.企业.更新失败": "更新失败",
  "页面.企业.更新失败请重试": "更新失败，请重试",
  "页面.企业.更新成功": "更新成功",
  "页面.企业.更新时间": "更新时间",
  "页面.企业.更新时间范围": "更新时间",
  "页面.企业.有Logo": "有 Logo",
  "页面.企业.未认证": "未认证",
  "页面.企业.正在创建": "正在创建...",
  "页面.企业.正在删除N个企业": "正在删除 {count} 个企业...",
  "页面.企业.正在更新": "正在更新...",
  "页面.企业.确定要删除这个企业吗": "确定要删除这个企业吗？",
  "页面.企业.编辑": "编辑",
  "页面.企业.编辑企业": "编辑企业",
  "页面.企业.联系人": "联系人",
  "页面.企业.联系人信息": "联系人信息",
  "页面.企业.联系人姓名": "联系人姓名",
  "页面.企业.联系人姓名不能超过50": "联系人姓名不能超过50个字符",
  "页面.企业.联系人职位": "联系人职位",
  "页面.企业.联系人职位不能超过50": "联系人职位不能超过50个字符",
  "页面.企业.联系电话": "联系电话",
  "页面.企业.联系电话不能超过20": "联系电话不能超过20个字符",
  "页面.企业.获取详情失败": "获取详情失败",
  "页面.企业.获取详情失败请重试": "获取详情失败，请重试",
  "页面.企业.裁剪Logo": "裁剪Logo",
  "页面.企业.认证材料": "认证材料",
  "页面.企业.认证材料extra": "支持JPG/PNG/PDF格式，单个文件不超过10MB",
  "页面.企业.认证材料格式说明": "支持JPG/PNG/PDF格式，仅后台可见，最多10个文件",
  "页面.企业.认证状态": "认证状态",
  "页面.企业.认证状态开启说明": "开启后显示蓝盾/认证标识，且职位排名加权",
  "页面.企业.请输入企业全称": "请输入企业全称",
  "页面.企业.请输入企业简称可选": "请输入企业简称（可选）",
  "页面.企业.请输入公司地址非标地址": "请输入公司地址（非标地址）",
  "页面.企业.请输入联系人姓名": "请输入联系人姓名",
  "页面.企业.请输入联系人职位": "请输入联系人职位",
  "页面.企业.请选择企业规模": "请选择企业规模",
  "页面.企业.请选择所属行业": "请选择所属行业",
  "页面.企业.选择修改员工": "选择员工",
  "页面.企业配置.企业规模": "企业规模",
  "页面.企业配置.创建时间": "创建时间",
  "页面.企业配置.创建时间说明": "创建时间，hover 显示原始值",
  "页面.企业配置.删除": "删除",
  "页面.企业配置.删除失败请重试": "删除失败，请重试",
  "页面.企业配置.名称": "名称",
  "页面.企业配置.名称value字段": "名称（value字段）",
  "页面.企业配置.名称不能为空": "名称不能为空",
  "页面.企业配置.启用": "启用",
  "页面.企业配置.成功删除N个": "成功删除 {count} 个{typeLabel}",
  "页面.企业配置.成功删除部分失败": "成功删除 {ok} 个，失败 {fail} 个",
  "页面.企业配置.批量删除": "批量删除",
  "页面.企业配置.排序": "排序",
  "页面.企业配置.排序顺序说明": "排序顺序（数字越小越靠前）",
  "页面.企业配置.操作": "操作",
  "页面.企业配置.新建": "新建{typeLabel}",
  "页面.企业配置.新建行业": "新建行业",
  "页面.企业配置.是否启用": "是否启用",
  "页面.企业配置.更新失败": "更新失败",
  "页面.企业配置.更新失败请重试": "更新失败，请重试！",
  "页面.企业配置.更新成功": "更新成功",
  "页面.企业配置.正在删除N个": "正在删除 {count} 个{typeLabel}...",
  "页面.企业配置.正在更新": "正在更新",
  "页面.企业配置.正在添加": "正在添加",
  "页面.企业配置.添加失败": "添加失败",
  "页面.企业配置.添加失败请重试": "添加失败，请重试！",
  "页面.企业配置.添加子级": "添加子级",
  "页面.企业配置.添加成功": "添加成功",
  "页面.企业配置.状态": "状态",
  "页面.企业配置.确定删除行业项": "确定要删除该行业项吗？子级会一并删除。",
  "页面.企业配置.确定要删除这个吗": "确定要删除这个{typeLabel}吗？",
  "页面.企业配置.禁用": "禁用",
  "页面.企业配置.管理": "{typeLabel}管理",
  "页面.企业配置.编辑": "编辑",
  "页面.企业配置.编辑类型": "编辑{typeLabel}",
  "页面.企业配置.行业": "行业",
  "页面.企业配置.配置": "配置",
  "页面.内容.创建时间": "创建时间",
  "页面.内容.合作媒体.Logo图片": "Logo",
  "页面.内容.合作媒体.Logo链接": "Logo 链接",
  "页面.内容.合作媒体.上传Logo": "上传Logo",
  "页面.内容.合作媒体.媒体名称": "媒体名称",
  "页面.内容.合作媒体.媒体名称占位": "请输入媒体名称",
  "页面.内容.合作媒体.官网链接": "官网链接",
  "页面.内容.合作媒体.展示名称": "展示名称",
  "页面.内容.合作媒体.成功删除N个": "已删除 {n} 个媒体",
  "页面.内容.合作媒体.成功删除部分失败": "已删除 {ok} 个，{fail} 个失败",
  "页面.内容.合作媒体.新建": "新建媒体",
  "页面.内容.合作媒体.新建标题": "新建合作媒体",
  "页面.内容.合作媒体.正在删除N个": "正在删除 {n} 个媒体...",
  "页面.内容.合作媒体.正在更新": "正在更新...",
  "页面.内容.合作媒体.正在添加": "正在添加...",
  "页面.内容.合作媒体.确定删除": "删除这个合作媒体？",
  "页面.内容.合作媒体.确定删除N个": "删除选中的 {n} 个合作媒体？",
  "页面.内容.合作媒体.编辑标题": "编辑合作媒体",
  "页面.内容.合作媒体.联系人": "联系人",
  "页面.内容.合作媒体.联系电话": "联系电话",
  "页面.内容.合作媒体.裁剪Logo": "裁剪Logo",
  "页面.内容.合作媒体.请输入媒体名称": "请输入媒体名称",
  "页面.内容.合作媒体.页面标题": "合作媒体",
  "页面.内容.排序": "排序",
  "页面.内容.请补全多语言": "请补全多语言",
  "页面.内容.资讯.上传封面": "上传封面",
  "页面.内容.资讯.价格": "价格",
  "页面.内容.资讯.加载合作媒体失败": "合作媒体加载失败",
  "页面.内容.资讯.原文链接": "原文链接",
  "页面.内容.资讯.发布平台": "发布平台",
  "页面.内容.资讯.发布时间": "发布时间",
  "页面.内容.资讯.发布状态": "发布状态",
  "页面.内容.资讯.发布链接": "发布链接",
  "页面.内容.资讯.合作媒体": "合作媒体",
  "页面.内容.资讯.封面图片": "封面图",
  "页面.内容.资讯.封面链接": "封面链接",
  "页面.内容.资讯.已下架": "已下架",
  "页面.内容.资讯.已发布": "已发布",
  "页面.内容.资讯.成功删除N个": "已删除 {n} 条资讯",
  "页面.内容.资讯.成功删除部分失败": "已删除 {ok} 条，{fail} 条失败",
  "页面.内容.资讯.摘要": "摘要",
  "页面.内容.资讯.文章链接": "文章链接",
  "页面.内容.资讯.新建": "发布资讯",
  "页面.内容.资讯.新建标题": "发布资讯",
  "页面.内容.资讯.标题": "标题",
  "页面.内容.资讯.正在删除N个": "正在删除 {n} 条资讯...",
  "页面.内容.资讯.正在更新": "正在更新...",
  "页面.内容.资讯.正在添加": "正在添加...",
  "页面.内容.资讯.正文": "正文",
  "页面.内容.资讯.添加文章链接": "添加文章链接",
  "页面.内容.资讯.确定删除": "删除这条资讯？",
  "页面.内容.资讯.确定删除N个": "删除选中的 {n} 条资讯？",
  "页面.内容.资讯.编辑标题": "编辑资讯",
  "页面.内容.资讯.草稿": "草稿",
  "页面.内容.资讯.裁剪封面": "裁剪封面",
  "页面.内容.资讯.请输入发布平台": "请输入发布平台",
  "页面.内容.资讯.请输入发布链接": "请输入发布链接",
  "页面.内容.资讯.请输入正文": "请输入正文",
  "页面.内容.资讯.请选择合作媒体": "请选择合作媒体",
  "页面.内容.资讯.页面标题": "资讯发布",
  "页面.反馈.举报人ID": "举报人 ID",
  "页面.反馈.举报人ID说明": "提交本次简历举报的用户 ID",
  "页面.反馈.举报原因": "举报原因",
  "页面.反馈.举报原因说明": "来自 resume_complaint_type 字典，可按原因筛选",
  "页面.反馈.举报说明": "举报说明",
  "页面.反馈.举报说明说明": "用户填写的具体说明；选择“其他”时必须填写",
  "页面.反馈.内容": "内容",
  "页面.反馈.内容说明": "反馈内容",
  "页面.反馈.创建时间": "创建时间",
  "页面.反馈.创建时间说明": "创建时间，hover 显示原始值",
  "页面.反馈.加载详情中": "正在加载反馈详情...",
  "页面.反馈.反馈ID": "反馈 ID",
  "页面.反馈.反馈ID说明": "反馈 ID，点击查看详情",
  "页面.反馈.岗位反馈记录.创建开始时间": "创建开始时间",
  "页面.反馈.岗位反馈记录.创建时间": "创建时间",
  "页面.反馈.岗位反馈记录.创建时间说明": "创建时间，hover 显示原始值",
  "页面.反馈.岗位反馈记录.创建结束时间": "创建结束时间",
  "页面.反馈.岗位反馈记录.加载详情中": "加载反馈记录详情...",
  "页面.反馈.岗位反馈记录.匿名ID": "匿名 ID",
  "页面.反馈.岗位反馈记录.匿名ID说明": "游客提交反馈时使用的 anonymous_id",
  "页面.反馈.岗位反馈记录.反馈内容": "反馈内容",
  "页面.反馈.岗位反馈记录.反馈内容说明": "用户手填的岗位反馈内容",
  "页面.反馈.岗位反馈记录.反馈记录ID": "反馈记录 ID",
  "页面.反馈.岗位反馈记录.反馈记录ID说明": "反馈记录 ID，点击查看详情",
  "页面.反馈.岗位反馈记录.反馈项": "反馈项",
  "页面.反馈.岗位反馈记录.反馈项说明": "C 端提交的岗位反馈项，来自 jd_feedback_type 字典",
  "页面.反馈.岗位反馈记录.岗位ID": "岗位 ID",
  "页面.反馈.岗位反馈记录.岗位ID说明": "被反馈的岗位 ID，点击查看岗位详情",
  "页面.反馈.岗位反馈记录.暂无数据": "暂无数据",
  "页面.反馈.岗位反馈记录.用户ID": "用户 ID",
  "页面.反馈.岗位反馈记录.用户ID说明": "提交反馈的 C 端用户 ID，点击查看用户详情",
  "页面.反馈.岗位反馈记录.用户详情": "用户详情",
  "页面.反馈.岗位反馈记录.获取详情失败": "获取详情失败",
  "页面.反馈.岗位反馈记录.详情标题": "岗位反馈记录详情",
  "页面.反馈.岗位反馈记录.请求失败": "请求失败",
  "页面.反馈.岗位反馈记录.请选择反馈项": "请选择反馈项",
  "页面.反馈.岗位反馈记录.页面标题": "岗位反馈记录",
  "页面.反馈.岗位投诉列表.页面标题": "岗位投诉列表",
  "页面.反馈.意见反馈列表.页面标题": "意见反馈列表",
  "页面.反馈.投诉对象ID": "投诉对象 ID",
  "页面.反馈.投诉对象ID说明": "投诉对象 ID",
  "页面.反馈.投诉对象类型": "投诉对象类型",
  "页面.反馈.投诉对象类型说明": "如 jd",
  "页面.反馈.投诉类型": "投诉类型",
  "页面.反馈.投诉类型说明": "岗位投诉类型（仅岗位投诉有值）；岗位投诉列表可筛选",
  "页面.反馈.操作": "操作",
  "页面.反馈.暂无数据": "暂无数据",
  "页面.反馈.用户ID": "用户 ID",
  "页面.反馈.用户ID说明": "提交用户 ID，点击查看用户详情",
  "页面.反馈.用户详情": "用户详情",
  "页面.反馈.简历ID": "简历 ID",
  "页面.反馈.简历ID说明": "被举报的简历 ID，点击查看简历详情",
  "页面.反馈.简历投诉列表.页面标题": "简历投诉列表",
  "页面.反馈.简历投诉详情": "简历投诉详情",
  "页面.反馈.类别": "类别",
  "页面.反馈.类别.岗位投诉": "岗位投诉",
  "页面.反馈.类别.意见反馈": "意见反馈",
  "页面.反馈.类别.简历投诉": "简历投诉",
  "页面.反馈.类别说明": "反馈类别",
  "页面.反馈.类型.全部": "全部",
  "页面.反馈.缺少详情参数": "缺少反馈详情参数",
  "页面.反馈.获取详情失败": "获取反馈详情失败",
  "页面.反馈.被举报用户ID": "被举报用户 ID",
  "页面.反馈.被举报用户ID说明": "由被举报简历的归属关系确定，点击查看用户详情",
  "页面.反馈.详情标题": "反馈详情",
  "页面.反馈.请求失败": "请求失败",
  "页面.反馈.请选择举报原因": "请选择举报原因",
  "页面.反馈.请选择投诉类型": "请选择投诉类型",
  "页面.反馈.账号申诉.凭证文件": "凭证文件",
  "页面.反馈.账号申诉.加载详情中": "正在加载申诉详情...",
  "页面.反馈.账号申诉.处理失败": "处理账号申诉失败",
  "页面.反馈.账号申诉.处理成功": "申诉已通过，账号限制已解除",
  "页面.反馈.账号申诉.审核人ID": "审核人 ID",
  "页面.反馈.账号申诉.审核回复": "审核回复",
  "页面.反馈.账号申诉.审核时间": "审核时间",
  "页面.反馈.账号申诉.提交时间": "提交时间",
  "页面.反馈.账号申诉.暂无数据": "暂无申诉数据",
  "页面.反馈.账号申诉.状态": "申诉状态",
  "页面.反馈.账号申诉.状态.审核中": "审核中",
  "页面.反馈.账号申诉.状态.已提交": "已提交",
  "页面.反馈.账号申诉.状态.已通过": "已通过",
  "页面.反馈.账号申诉.状态.已驳回": "已驳回",
  "页面.反馈.账号申诉.用户": "申诉用户",
  "页面.反馈.账号申诉.用户ID": "用户 ID",
  "页面.反馈.账号申诉.申诉ID": "申诉 ID",
  "页面.反馈.账号申诉.申诉原因": "申诉原因",
  "页面.反馈.账号申诉.申诉编号": "申诉编号",
  "页面.反馈.账号申诉.申诉说明": "申诉说明",
  "页面.反馈.账号申诉.确认解除封禁": "通过申诉并解除账号封禁？",
  "页面.反馈.账号申诉.确认解除禁言": "通过申诉并解除 IM 禁言？",
  "页面.反馈.账号申诉.确认解除说明": "操作后申诉状态将变为已通过，用户对应的限制会立即解除。",
  "页面.反馈.账号申诉.获取详情失败": "获取申诉详情失败",
  "页面.反馈.账号申诉.解除封禁": "解除封禁",
  "页面.反馈.账号申诉.解除时间": "解除时间",
  "页面.反馈.账号申诉.解除禁言": "解除禁言",
  "页面.反馈.账号申诉.详情标题": "账号申诉详情",
  "页面.反馈.账号申诉.账号": "账号",
  "页面.反馈.账号申诉.限制原因": "限制原因",
  "页面.反馈.账号申诉.限制开始时间": "限制开始时间",
  "页面.反馈.账号申诉.限制状态": "限制状态",
  "页面.反馈.账号申诉.限制状态.已到期": "已到期",
  "页面.反馈.账号申诉.限制状态.已解除": "已解除",
  "页面.反馈.账号申诉.限制状态.生效中": "生效中",
  "页面.反馈.账号申诉.限制类型": "限制类型",
  "页面.反馈.账号申诉.限制类型.封禁": "账号封禁",
  "页面.反馈.账号申诉.限制类型.禁言": "IM 禁言",
  "页面.反馈.账号申诉.限制结束时间": "计划结束时间",
  "页面.反馈.账号申诉.限制说明": "限制说明",
  "页面.反馈.账号申诉.页面标题": "账号申诉列表",
  "页面.反馈.账号限制.匿名简历": "匿名简历",
  "页面.反馈.账号限制.封禁": "封禁",
  "页面.反馈.账号限制.封禁成功": "已封禁该用户",
  "页面.反馈.账号限制.已封禁": "已封禁",
  "页面.反馈.账号限制.已禁言": "已禁言",
  "页面.反馈.账号限制.操作失败": "账号限制操作失败",
  "页面.反馈.账号限制.无账号": "无账号",
  "页面.反馈.账号限制.正常": "正常",
  "页面.反馈.账号限制.状态": "账号限制",
  "页面.反馈.账号限制.状态说明": "被举报用户当前的禁言或封禁状态",
  "页面.反馈.账号限制.确认封禁": "确认封禁该用户？",
  "页面.反馈.账号限制.确认封禁说明": "封禁后不能访问 App 中所有需要登录的接口，但仍可提交账号申诉。",
  "页面.反馈.账号限制.确认禁言": "确认禁言该用户？",
  "页面.反馈.账号限制.确认禁言说明": "禁言后不能发送 IM 消息，其他登录功能不受影响。",
  "页面.反馈.账号限制.确认解除": "确认解除当前限制？",
  "页面.反馈.账号限制.禁言": "禁言",
  "页面.反馈.账号限制.禁言成功": "已禁言该用户",
  "页面.反馈.账号限制.解除": "解除",
  "页面.反馈.账号限制.解除成功": "已解除账号限制",
  "页面.员工.APIKey名称": "API Key 名称",
  "页面.员工.HTTP方法": "HTTP 方法",
  "页面.员工.Trace ID": "Trace ID",
  "页面.员工.User-Agent": "User-Agent",
  "页面.员工.仅支持小写字母数字下划线": "仅支持小写字母、数字、下划线",
  "页面.员工.保存角色权限": "保存角色权限",
  "页面.员工.全部操作记录": "全部操作记录",
  "页面.员工.关联账号": "关联账号",
  "页面.员工.关联账号占位": "例如呼叫中心登录邮箱",
  "页面.员工.关联账号说明": "与呼叫中心（如 OMICall）登录账号对应，用于一人一号外呼等能力",
  "页面.员工.关键词搜索": "关键词搜索",
  "页面.员工.分配角色": "分配角色",
  "页面.员工.创建失败": "创建失败",
  "页面.员工.创建失败重试": "创建失败，请重试",
  "页面.员工.创建成功": "创建成功",
  "页面.员工.创建时间": "创建时间",
  "页面.员工.删除后该账号将无法登录": "删除后该账号将无法登录。",
  "页面.员工.删除失败": "删除失败",
  "页面.员工.删除失败重试": "删除失败，请重试",
  "页面.员工.删除成功": "删除成功",
  "页面.员工.删除角色不可恢复": "删除后该角色不可恢复。",
  "页面.员工.刷新": "刷新",
  "页面.员工.加载权限目录失败": "加载权限目录失败",
  "页面.员工.加载权限目录失败重试": "加载权限目录失败，请重试",
  "页面.员工.加载角色失败": "加载角色失败",
  "页面.员工.加载角色失败重试": "加载角色失败，请重试",
  "页面.员工.同步Manifest": "同步 Manifest",
  "页面.员工.同步失败": "同步失败",
  "页面.员工.同步失败重试": "同步失败，请重试",
  "页面.员工.同步完成": "同步完成：新增 {created}，更新 {updated}，无变化 {unchanged}",
  "页面.员工.员工列表": "员工列表",
  "页面.员工.客户端IP": "客户端 IP",
  "页面.员工.密码已重置": "密码已重置",
  "页面.员工.当前可分配N项权限": "当前可分配 {n} 项权限，点击名称可全选/反选该节点下所有叶子",
  "页面.员工.当前角色": "当前角色",
  "页面.员工.我的操作记录": "我的操作记录",
  "页面.员工.按权限key搜索": "按权限 key 搜索（例如：staff.role）",
  "页面.员工.接口摘要": "接口摘要",
  "页面.员工.搜索用户名昵称": "搜索用户名、昵称",
  "页面.员工.操作": "操作",
  "页面.员工.操作人ID": "操作人ID",
  "页面.员工.操作时间": "操作时间",
  "页面.员工.操作时间范围": "操作时间范围",
  "页面.员工.新密码": "新密码",
  "页面.员工.新建角色": "新建角色",
  "页面.员工.昵称": "昵称",
  "页面.员工.暂无可分配权限": "暂无可分配权限",
  "页面.员工.暂无角色": "暂无角色",
  "页面.员工.更新失败": "更新失败",
  "页面.员工.更新失败重试": "更新失败，请重试",
  "页面.员工.更新成功": "更新成功",
  "页面.员工.更新时间": "更新时间",
  "页面.员工.未激活": "未激活",
  "页面.员工.权限可见即可编辑": "权限可见即可编辑",
  "页面.员工.权限可见即可编辑说明": "您只能看到并编辑自己已拥有的权限；为角色勾选/取消的权限会与角色原有权限合并后提交，您无权限的项将保持不变。",
  "页面.员工.权限树配置": "权限树配置",
  "页面.员工.查看": "查看",
  "页面.员工.正在保存角色权限": "正在保存角色权限...",
  "页面.员工.正在创建": "正在创建...",
  "页面.员工.正在创建角色": "正在创建角色...",
  "页面.员工.正在删除": "正在删除...",
  "页面.员工.正在删除角色": "正在删除角色...",
  "页面.员工.正在加载该角色权限": "正在加载该角色权限…",
  "页面.员工.正在同步权限清单": "正在同步权限清单...",
  "页面.员工.正在更新": "正在更新...",
  "页面.员工.正在更新角色": "正在更新角色...",
  "页面.员工.活跃": "活跃",
  "页面.员工.状态": "状态",
  "页面.员工.状态码": "状态码",
  "页面.员工.用户ID": "用户ID",
  "页面.员工.用户ID点击详情": "用户 ID，点击查看详情",
  "页面.员工.用户名": "用户名",
  "页面.员工.确定要删除该员工吗": "确定要删除该员工吗？",
  "页面.员工.确认删除角色": "确认删除该角色？",
  "页面.员工.系统内置角色不允许删除": "系统内置角色不允许删除",
  "页面.员工.系统管理员不可修改": "系统管理员（system_admin）角色权限不允许在页面修改",
  "页面.员工.编辑": "编辑",
  "页面.员工.编辑角色": "编辑角色",
  "页面.员工.至少8字符": "至少 8 个字符",
  "页面.员工.获取详情失败": "获取详情失败",
  "页面.员工.获取详情失败请重试": "获取详情失败，请重试",
  "页面.员工.角色": "角色",
  "页面.员工.角色名称": "角色名称",
  "页面.员工.角色已更新": "角色已更新",
  "页面.员工.角色权限保存失败": "角色权限保存失败",
  "页面.员工.角色权限保存失败重试": "角色权限保存失败，请重试",
  "页面.员工.角色权限保存成功": "角色权限保存成功",
  "页面.员工.角色权限只读": "角色权限只读",
  "页面.员工.角色管理": "角色管理",
  "页面.员工.角色编码": "角色编码",
  "页面.员工.角色编码占位": "例如：operation_manager",
  "页面.员工.认证方式": "认证方式",
  "页面.员工.记录ID": "记录ID",
  "页面.员工.请先在左侧选择角色": "请先在左侧选择角色",
  "页面.员工.请先选择角色": "请先选择角色",
  "页面.员工.请求路径": "请求路径",
  "页面.员工.请输入新密码": "请输入新密码",
  "页面.员工.请输入角色名称": "请输入角色名称",
  "页面.员工.请输入角色编码": "请输入角色编码",
  "页面.员工.请选择状态": "请选择状态",
  "页面.员工.请选择角色": "请选择角色（可多选）",
  "页面.员工.路径关键词": "路径关键词",
  "页面.员工.重置密码": "重置密码",
  "页面.商业化.拖拽调整权益顺序": "拖拽调整权益顺序",
  "页面.审核记录.不通过原因": "不通过原因",
  "页面.审核记录.不通过原因.ID说明": "不通过原因 ID（即 code）",
  "页面.审核记录.不通过原因.创建时间": "创建时间",
  "页面.审核记录.不通过原因.名称说明": "原因名称/字面量",
  "页面.审核记录.不通过原因.成功删除N个": "成功删除 {n} 个",
  "页面.审核记录.不通过原因.成功删除部分失败": "成功删除 {ok} 个，失败 {fail} 个",
  "页面.审核记录.不通过原因.排序": "排序",
  "页面.审核记录.不通过原因.新建": "新建原因",
  "页面.审核记录.不通过原因.正在删除N个": "正在删除 {n} 个...",
  "页面.审核记录.不通过原因.正在更新": "正在更新...",
  "页面.审核记录.不通过原因.正在添加": "正在添加...",
  "页面.审核记录.不通过原因.确定删除": "确定要删除该不通过原因吗？",
  "页面.审核记录.不通过原因.管理标题": "审核不通过原因管理",
  "页面.审核记录.不通过原因筛选": "选择不通过原因筛选",
  "页面.审核记录.不通过原因管理": "审核不通过原因管理",
  "页面.审核记录.最近7天": "最近7天",
  "页面.审核记录.最近一个月": "最近一个月",
  "页面.审核记录.审核备注": "审核备注",
  "页面.审核记录.审核记录": "审核记录",
  "页面.审核记录.岗位视角": "岗位视角",
  "页面.审核记录.当天": "当天",
  "页面.审核记录.时间": "时间",
  "页面.审核记录.查看岗位": "查看岗位",
  "页面.审核记录.记录视角": "记录视角",
  "页面.审核记录.选择审核人": "选择审核人",
  "页面.岗位.AI评分": "AI评分",
  "页面.岗位.AI评分说明": "展示 AI 评估等级、分数和主要原因",
  "页面.岗位.Boost状态": "Boost 状态",
  "页面.岗位.C端联系记录": "C 端联系记录",
  "页面.岗位.N个文件上传失败": "{n} 个文件上传失败，请重试",
  "页面.岗位.Urgent": "Urgent",
  "页面.岗位.Urgent使用成功": "Urgent 道具使用成功",
  "页面.岗位.上传岗位文件或图片": "上传岗位文件或图片",
  "页面.岗位.上午": "上午",
  "页面.岗位.下午": "下午",
  "页面.岗位.下架": "下架",
  "页面.岗位.下架失败": "下架失败",
  "页面.岗位.下架失败重试": "下架失败，请重试",
  "页面.岗位.下架成功": "下架成功",
  "页面.岗位.不通过原因必选": "不通过原因（至少选一项）",
  "页面.岗位.不限": "不限",
  "页面.岗位.中文标签": "中文 (zh_CN)",
  "页面.岗位.临时工": "临时工",
  "页面.岗位.仅周末": "仅周末",
  "页面.岗位.仅工作日": "仅工作日",
  "页面.岗位.从输入定位圈定": "从输入定位圈定",
  "页面.岗位.付费岗位": "付费岗位",
  "页面.岗位.代发岗位场景企业不可修改": "代发岗位场景下，企业已预设，不可修改",
  "页面.岗位.任务ID": "任务ID",
  "页面.岗位.任务ID说明": "有任务ID表示岗位由任务生成，点击可查看任务详情",
  "页面.岗位.任务列表": "任务列表",
  "页面.岗位.任务已提交正在生成": "任务已提交，正在生成中...",
  "页面.岗位.任务正在后台生成中": "任务正在后台生成中",
  "页面.岗位.任务详情": "任务详情",
  "页面.岗位.任职要求": "任职要求",
  "页面.岗位.企业ID": "企业ID",
  "页面.岗位.企业关键词搜索": "请输入企业关键词搜索（至少2个字符，可选，不选择则进入公海池）",
  "页面.岗位.企业创建成功": "企业创建成功，已自动选中",
  "页面.岗位.企业名称": "企业名称",
  "页面.岗位.企业名称只读说明": "此为渠道/任务提取的原始企业名称，仅供参考、不可编辑。实际展示以「关联企业」为准，请在上方「关联企业」处选择或编辑。",
  "页面.岗位.企业名称表单说明": "岗位上的企业名称文本，来自创建渠道或手动填写，与上方的「关联企业」无关联",
  "页面.岗位.企业名称说明": "岗位上的非结构化企业名称，与关联企业无关",
  "页面.岗位.优先级": "优先级",
  "页面.岗位.使用Urgent": "使用 Urgent",
  "页面.岗位.使用Urgent扣减说明": "将扣除岗位关联用户的 1 个 Urgent 道具，并刷新岗位排序。是否继续？",
  "页面.岗位.全职": "全职",
  "页面.岗位.全选": "全选",
  "页面.岗位.全部": "全部",
  "页面.岗位.全部岗位": "全部岗位",
  "页面.岗位.全部语言不传": "全部语言（不传）",
  "页面.岗位.公海池": "公海池",
  "页面.岗位.共N条": "共 {total} 条",
  "页面.岗位.关联企业": "关联企业",
  "页面.岗位.关联企业搜索说明": "输入企业全称或简称关键词搜索（至少2个字符），不选择则岗位进入公海池",
  "页面.岗位.关联企业说明": "关联企业 ID，点击查看企业详情",
  "页面.岗位.关键词匹配说明": "关键词匹配：岗位名称、岗位职责、福利待遇",
  "页面.岗位.关键词搜索": "关键词搜索",
  "页面.岗位.关闭": "关闭",
  "页面.岗位.兼职": "兼职",
  "页面.岗位.内容文件": "内容文件",
  "页面.岗位.内容文本": "内容文本",
  "页面.岗位.最大年龄": "最大年龄",
  "页面.岗位.最大薪资美元": "最大薪资（美元）",
  "页面.岗位.最小年龄": "最小年龄",
  "页面.岗位.最小年龄不能大于最大年龄": "最小年龄不能大于最大年龄",
  "页面.岗位.最小薪资美元": "最小薪资（美元）",
  "页面.岗位.最近7天": "最近7天",
  "页面.岗位.最近一个月": "最近一个月",
  "页面.岗位.最近提交翻译时间": "最近提交翻译时间",
  "页面.岗位.分数": "分数",
  "页面.岗位.分配": "分配",
  "页面.岗位.分配人": "分配人",
  "页面.岗位.分配任务管理": "分配任务管理",
  "页面.岗位.分配工作台": "分配工作台",
  "页面.岗位.分配成功": "分配成功",
  "页面.岗位.分配数量": "分配数量",
  "页面.岗位.分配数量占位": "不填则分配本组全部",
  "页面.岗位.分配数量范围提示": "分配数量须在 1～{max} 之间",
  "页面.岗位.分配状态": "分配状态",
  "页面.岗位.分配管理": "分配管理",
  "页面.岗位.分配结果": "分配结果",
  "页面.岗位.分配给该组": "分配给…",
  "页面.岗位.分配维度": "分配",
  "页面.岗位.创建": "创建",
  "页面.岗位.创建时间": "创建时间",
  "页面.岗位.创建时间说明": "创建时间，hover 显示原始值",
  "页面.岗位.删除岗位可恢复说明": "删除后可以恢复，但数据将不再显示在列表中。",
  "页面.岗位.刷新概览": "刷新概览",
  "页面.岗位.区间止": "区间止（如 20250305-000200）",
  "页面.岗位.区间止简版": "结束编号（纯数字）",
  "页面.岗位.区间起": "区间起（如 20250305-000001）",
  "页面.岗位.区间起简版": "起始编号（纯数字）",
  "页面.岗位.博士": "博士",
  "页面.岗位.原文": "原文",
  "页面.岗位.发布": "发布",
  "页面.岗位.发布失败": "发布失败",
  "页面.岗位.发布失败重试": "发布失败，请重试",
  "页面.岗位.发布成功": "发布成功",
  "页面.岗位.发布时间": "发布时间",
  "页面.岗位.发布来源": "发布来源",
  "页面.岗位.发布来源说明": "按岗位是否由用户发布筛选；用户发布为 jds.user_id 不为空",
  "页面.岗位.发布状态": "发布状态",
  "页面.岗位.取消分配": "取消分配",
  "页面.岗位.取消分配成功": "取消分配成功",
  "页面.岗位.取消分配数量": "取消分配数量",
  "页面.岗位.取消分配数量占位": "不填则取消本组全部",
  "页面.岗位.取消分配数量范围提示": "取消分配数量须在 1～{max} 之间",
  "页面.岗位.取消分配结果": "取消分配结果",
  "页面.岗位.取消岗位置顶失败": "取消岗位置顶失败，请重试",
  "页面.岗位.取消岗位置顶成功": "已取消岗位置顶",
  "页面.岗位.取消置顶": "取消置顶",
  "页面.岗位.只支持文档和图片格式": "只支持文档（Markdown、CSV、Excel、HTML、TXT、Word、PDF）和图片（JPG、PNG）格式",
  "页面.岗位.合同工": "合同工",
  "页面.岗位.同步刷新": "同步刷新",
  "页面.岗位.周": "周",
  "页面.岗位.周一": "周一",
  "页面.岗位.周一上午": "周一 上午",
  "页面.岗位.周一下午": "周一 下午",
  "页面.岗位.周三": "周三",
  "页面.岗位.周三上午": "周三 上午",
  "页面.岗位.周三下午": "周三 下午",
  "页面.岗位.周二": "周二",
  "页面.岗位.周二上午": "周二 上午",
  "页面.岗位.周二下午": "周二 下午",
  "页面.岗位.周五": "周五",
  "页面.岗位.周五上午": "周五 上午",
  "页面.岗位.周五下午": "周五 下午",
  "页面.岗位.周六": "周六",
  "页面.岗位.周六上午": "周六 上午",
  "页面.岗位.周六下午": "周六 下午",
  "页面.岗位.周四": "周四",
  "页面.岗位.周四上午": "周四 上午",
  "页面.岗位.周四下午": "周四 下午",
  "页面.岗位.周日": "周日",
  "页面.岗位.周日上午": "周日 上午",
  "页面.岗位.周日下午": "周日 下午",
  "页面.岗位.周结": "周结",
  "页面.岗位.基础信息": "基础信息",
  "页面.岗位.填入区间": "填入区间",
  "页面.岗位.复制失败请重试": "复制失败，请重试",
  "页面.岗位.大专": "大专",
  "页面.岗位.女": "女",
  "页面.岗位.学历要求": "学历要求",
  "页面.岗位.完工结算": "完工结算",
  "页面.岗位.定位": "定位",
  "页面.岗位.定位到我最后审核的": "定位到我最后审核的",
  "页面.岗位.定位失败重试": "定位失败，请重试",
  "页面.岗位.实习": "实习",
  "页面.岗位.审核": "审核",
  "页面.岗位.审核不通过": "审核不通过",
  "页面.岗位.审核人": "审核人",
  "页面.岗位.审核信息": "审核信息",
  "页面.岗位.审核备注选填": "审核备注（选填，最多 500 字）：",
  "页面.岗位.审核时间": "审核时间",
  "页面.岗位.审核状态": "审核状态",
  "页面.岗位.审核通过": "审核通过",
  "页面.岗位.审核通过但发布失败": "审核通过，但发布失败：{msg}",
  "页面.岗位.审核通过并已自动发布": "审核通过并已自动发布",
  "页面.岗位.审核通过自动发布": "审核通过自动发布",
  "页面.岗位.岗位ID": "岗位ID",
  "页面.岗位.岗位ID或编号": "岗位 ID 或编号",
  "页面.岗位.岗位ID点击详情": "岗位ID，点击查看详情",
  "页面.岗位.岗位ID精确查找": "岗位ID精确查找，传入时仅返回该ID的岗位",
  "页面.岗位.岗位信息": "岗位信息",
  "页面.岗位.岗位分组配置展示": "岗位分组配置",
  "页面.岗位.岗位原文主体语言": "岗位原文主体语言",
  "页面.岗位.岗位原文主体语言说明": "岗位原文（title）主体语言：zh_CN / en_US / km_KH",
  "页面.岗位.岗位名称": "岗位名称",
  "页面.岗位.岗位名称长度": "岗位名称长度为 1-100 个字符",
  "页面.岗位.岗位地址": "岗位地址",
  "页面.岗位.岗位地址tooltip": "支持地图选择或手动填写",
  "页面.岗位.岗位审核": "岗位审核",
  "页面.岗位.岗位审核带ID": "岗位审核（{id}）",
  "页面.岗位.岗位审核带标题": "岗位审核：{title}",
  "页面.岗位.岗位标签": "岗位标签",
  "页面.岗位.岗位标签关键词": "岗位标签关键词",
  "页面.岗位.岗位标签关键词说明": "按岗位标签关键词搜索",
  "页面.岗位.岗位标签多选": "岗位标签（多选）",
  "页面.岗位.岗位标签筛选说明": "岗位标签；筛选支持多选",
  "页面.岗位.岗位生成": "岗位生成",
  "页面.岗位.岗位等级": "岗位等级",
  "页面.岗位.岗位等级筛选说明": "按 AI 岗位等级筛选",
  "页面.岗位.岗位管理": "岗位管理",
  "页面.岗位.岗位编号": "岗位编号",
  "页面.岗位.岗位编号查找": "岗位编号精确查找，如 20250226-000001",
  "页面.岗位.岗位置顶失败": "岗位置顶失败，请重试",
  "页面.岗位.岗位置顶成功": "岗位已置顶",
  "页面.岗位.岗位翻译管理": "岗位翻译管理",
  "页面.岗位.岗位翻译管理带标题": "岗位翻译管理：{title}",
  "页面.岗位.岗位职责": "岗位职责",
  "页面.岗位.岗位详情": "岗位详情",
  "页面.岗位.工作地点": "工作地点",
  "页面.岗位.工作地点多选": "工作地点（多选）",
  "页面.岗位.工作开始时间": "工作开始时间",
  "页面.岗位.工作性质": "工作性质",
  "页面.岗位.工作日安排": "工作日安排",
  "页面.岗位.工作福利标签": "词库标签",
  "页面.岗位.工作福利标签列表说明": "来自标签词库（可多分类）；下拉仅展示已启用项；列表按当前界面语言展示，悬停标签可看分类",
  "页面.岗位.工作经验要求": "工作经验要求",
  "页面.岗位.工作结束时间": "工作结束时间",
  "页面.岗位.工作职责": "工作职责",
  "页面.岗位.工作要求": "工作要求",
  "页面.岗位.工种": "工种",
  "页面.岗位.已Boost": "已 Boost",
  "页面.岗位.已上架": "已上架",
  "页面.岗位.已下架": "已下架",
  "页面.岗位.已关联企业": "已关联企业",
  "页面.岗位.已分配": "已分配",
  "页面.岗位.已发布": "已发布",
  "页面.岗位.已审核": "已审核",
  "页面.岗位.已提交翻译": "已提交翻译",
  "页面.岗位.已标记为审核不通过": "已标记为审核不通过",
  "页面.岗位.已标记为稍后审核": "已标记为稍后审核",
  "页面.岗位.已添加N个文件任务": "已添加 {n} 个文件任务",
  "页面.岗位.已置顶": "已置顶",
  "页面.岗位.已跳过": "已跳过",
  "页面.岗位.已选N条": "已选 {n} 条",
  "页面.岗位.已预设企业不可修改": "已预设企业，不可修改",
  "页面.岗位.年龄要求": "年龄要求",
  "页面.岗位.开始生成": "开始生成",
  "页面.岗位.当前圈定": "当前圈定",
  "页面.岗位.当前岗位未发布是否仍复制链接": "当前岗位未发布，是否仍要复制链接？",
  "页面.岗位.当前数据条件": "当前数据条件",
  "页面.岗位.当前选中组": "当前选中",
  "页面.岗位.当天": "当天",
  "页面.岗位.待分配": "待分配",
  "页面.岗位.待发布": "待发布",
  "页面.岗位.待提交": "待提交",
  "页面.岗位.快速创建企业": "快速创建企业",
  "页面.岗位.性别不限": "不限",
  "页面.岗位.性别要求": "性别要求",
  "页面.岗位.成功N条失败N条": "成功 {success} 条，失败 {fail} 条",
  "页面.岗位.成功删除N个": "成功删除 {n} 个岗位",
  "页面.岗位.成功删除部分失败": "成功删除 {ok} 个，失败 {fail} 个",
  "页面.岗位.我审核的": "我审核的",
  "页面.岗位.我的任务": "我的任务",
  "页面.岗位.所有任务执行失败": "所有任务执行失败，{n} 个执行异常",
  "页面.岗位.所有任务执行完毕": "所有任务执行完毕，{n} 个执行成功",
  "页面.岗位.手动圈定": "手动圈定",
  "页面.岗位.手动填写地址": "手动填写地址：",
  "页面.岗位.手动填写非标地址": "手动填写非标地址",
  "页面.岗位.执行配置": "执行配置",
  "页面.岗位.批次任务": "批次任务（批次 ID: {id}）",
  "页面.岗位.批量上传文件": "批量上传文件",
  "页面.岗位.技能要求": "技能要求",
  "页面.岗位.拉取该语言预览": "拉取该语言预览",
  "页面.岗位.拖拉圈定": "拖拉圈定",
  "页面.岗位.招聘人数": "招聘人数",
  "页面.岗位.按分配人筛选": "按分配人筛选",
  "页面.岗位.按区间分配": "按区间分配",
  "页面.岗位.按区间取消分配": "按区间取消分配",
  "页面.岗位.按天分配概览": "按天分配概览",
  "页面.岗位.按编号分配": "按编号分配",
  "页面.岗位.按编号取消分配": "按编号取消分配",
  "页面.岗位.按选中分配": "按选中分配",
  "页面.岗位.按选中取消分配": "按选中取消分配",
  "页面.岗位.提交": "提交",
  "页面.岗位.提交失败": "提交失败",
  "页面.岗位.提交失败请重试": "提交失败，请重试",
  "页面.岗位.提交失败重试": "提交失败，请重试",
  "页面.岗位.提交并审核": "提交并审核",
  "页面.岗位.提交翻译": "提交翻译",
  "页面.岗位.提交翻译成功": "提交翻译成功",
  "页面.岗位.操作分配人": "操作分配人",
  "页面.岗位.操作失败": "操作失败",
  "页面.岗位.操作失败重试": "操作失败，请重试",
  "页面.岗位.收起手动填写": "收起手动填写",
  "页面.岗位.新建岗位": "新建岗位",
  "页面.岗位.无法获取当前用户信息": "无法获取当前用户信息",
  "页面.岗位.无额外条件": "无额外条件（即全部数据）",
  "页面.岗位.日": "日",
  "页面.岗位.日期提示文案": "切换日期后会自动刷新当天所有分配段",
  "页面.岗位.日结": "日结",
  "页面.岗位.时": "时",
  "页面.岗位.时间": "时间",
  "页面.岗位.时间信息": "时间信息",
  "页面.岗位.昨天": "昨天",
  "页面.岗位.是否已提交翻译": "是否已提交翻译",
  "页面.岗位.暂无任务请点击添加": "暂无任务，请点击上方按钮添加",
  "页面.岗位.暂无分组数据": "暂无分组数据（与当前列表筛选一致）",
  "页面.岗位.暂无匹配岗位分组配置": "当前岗位标签未命中岗位分组配置",
  "页面.岗位.暂无您的审核记录": "暂无您的审核记录",
  "页面.岗位.更多": "更多",
  "页面.岗位.更新时间": "更新时间",
  "页面.岗位.月": "月",
  "页面.岗位.月结": "月结",
  "页面.岗位.有未提交任务关闭说明": "当前有未提交的任务，关闭后将清空，确定要关闭吗？",
  "页面.岗位.未Boost": "未 Boost",
  "页面.岗位.未分配": "未分配",
  "页面.岗位.未审核": "未审核",
  "页面.岗位.本岗位审核记录": "本岗位审核记录",
  "页面.岗位.本次工作台数据共N条": "本次工作台数据共 {n} 条",
  "页面.岗位.本科": "本科",
  "页面.岗位.本组共N条": "本组共 {n} 条",
  "页面.岗位.条数": "条数",
  "页面.岗位.来自岗位详情接口切换Tab不会清空": "来自岗位详情接口，切换 Tab 不会清空。",
  "页面.岗位.某语言预览拉取成功": "{lang} 预览拉取成功",
  "页面.岗位.查看原文": "查看原文",
  "页面.岗位.查看审核记录": "查看审核记录",
  "页面.岗位.查询成功": "查询成功",
  "页面.岗位.查询状态": "查询状态",
  "页面.岗位.查询翻译任务状态": "查询翻译任务状态",
  "页面.岗位.校验失败": "校验失败",
  "页面.岗位.正在上传文件并提交任务": "正在上传文件并提交任务...",
  "页面.岗位.正在下架": "正在下架...",
  "页面.岗位.正在创建": "正在创建...",
  "页面.岗位.正在删除N个": "正在删除 {n} 个岗位...",
  "页面.岗位.正在发布": "正在发布...",
  "页面.岗位.正在取消置顶岗位": "正在取消置顶...",
  "页面.岗位.正在打开上一条岗位": "正在打开上一条岗位...",
  "页面.岗位.正在打开下一条待审核": "正在打开下一条待审核岗位...",
  "页面.岗位.正在更新": "正在更新...",
  "页面.岗位.正在标记稍后审核": "正在标记稍后审核...",
  "页面.岗位.正在置顶岗位": "正在置顶岗位...",
  "页面.岗位.步骤1选择数据段": "步骤1：选择要操作的数据段",
  "页面.岗位.步骤2调整并提交": "步骤2：调整区间并提交",
  "页面.岗位.池与关联": "池/关联",
  "页面.岗位.没有上一条可返回": "没有上一条可返回",
  "页面.岗位.没有更多待审核岗位": "没有更多待审核岗位",
  "页面.岗位.添加生成任务": "添加生成任务",
  "页面.岗位.添加纯文本任务": "添加纯文本任务",
  "页面.岗位.清空": "清空",
  "页面.岗位.点击展开查看完整返回": "点击展开查看完整返回",
  "页面.岗位.用户": "用户",
  "页面.岗位.用户ID": "用户ID",
  "页面.岗位.用户ID说明": "联系该岗位的 C 端用户 ID，点击可跳转求职用户详情",
  "页面.岗位.用户信息说明": "用户信息（用户已删除或不存在时为空）",
  "页面.岗位.男": "男",
  "页面.岗位.目标语言": "目标语言",
  "页面.岗位.硕士": "硕士",
  "页面.岗位.确定关闭": "确定关闭",
  "页面.岗位.确定删除岗位": "确定要删除这个岗位吗？",
  "页面.岗位.确定取消该区间分配": "确定取消该区间的分配？",
  "页面.岗位.确定取消该组分配": "确定取消该组的分配？",
  "页面.岗位.确认使用Urgent": "确认使用 Urgent",
  "页面.岗位.确认关闭": "确认关闭",
  "页面.岗位.福利待遇": "福利待遇",
  "页面.岗位.稍后审核": "稍后再审",
  "页面.岗位.筛选.地点与标签": "地点与标签",
  "页面.岗位.筛选.基础信息": "基础信息",
  "页面.岗位.筛选.岗位与池": "岗位与池",
  "页面.岗位.筛选.数据源": "数据源",
  "页面.岗位.筛选.联系与渠道": "联系与渠道",
  "页面.岗位.筛选.薪资与任职": "薪资与任职",
  "页面.岗位.管理分配任务": "管理分配任务",
  "页面.岗位.管理视角": "管理视角",
  "页面.岗位.粘贴编号列表": "粘贴岗位编号列表",
  "页面.岗位.经验0到3年": "0-3年",
  "页面.岗位.经验10年以上": "10年以上",
  "页面.岗位.经验1到3年": "1-3年",
  "页面.岗位.经验1年以内": "1年以内",
  "页面.岗位.经验3到5年": "3-5年",
  "页面.岗位.经验3年以上": "3年以上",
  "页面.岗位.经验5到10年": "5-10年",
  "页面.岗位.经验不限": "不限",
  "页面.岗位.结构化内容": "结构化内容",
  "页面.岗位.继续编辑": "继续编辑",
  "页面.岗位.编号列表提示": "支持英文逗号、中文逗号、空格、换行分隔",
  "页面.岗位.编号区间": "编号区间",
  "页面.岗位.编号日期": "编号日期",
  "页面.岗位.编辑岗位": "编辑岗位",
  "页面.岗位.置顶": "置顶",
  "页面.岗位.翻译": "翻译",
  "页面.岗位.翻译预览": "翻译预览",
  "页面.岗位.职位描述": "岗位职责",
  "页面.岗位.联系人": "联系人",
  "页面.岗位.联系人姓名": "联系人姓名",
  "页面.岗位.联系人电话": "联系人电话",
  "页面.岗位.联系时间": "联系时间",
  "页面.岗位.联系时间说明": "用户查看该岗位联系方式的时间",
  "页面.岗位.联系电话": "联系电话",
  "页面.岗位.联系电话运营商": "联系电话运营商",
  "页面.岗位.联系电话运营商说明": "联系电话运营商标定（配置匹配），用于精确筛选",
  "页面.岗位.自动创建岗位": "自动创建岗位",
  "页面.岗位.自动发布岗位": "自动发布岗位",
  "页面.岗位.自发布": "用户发布",
  "页面.岗位.英文标签": "英文 (en_US)",
  "页面.岗位.草稿": "草稿",
  "页面.岗位.获取任务详情失败": "获取任务详情失败",
  "页面.岗位.获取任务详情失败重试": "获取任务详情失败，请重试",
  "页面.岗位.获取企业详情失败": "获取企业详情失败",
  "页面.岗位.获取企业详情失败重试": "获取企业详情失败，请重试",
  "页面.岗位.获取岗位详情失败": "获取岗位详情失败",
  "页面.岗位.获取岗位详情失败重试": "获取岗位详情失败，请重试",
  "页面.岗位.获取批次任务失败": "获取批次任务失败",
  "页面.岗位.获取批次任务失败重试": "获取批次任务失败，请重试",
  "页面.岗位.获取详情失败": "获取详情失败",
  "页面.岗位.获取详情失败重试": "获取详情失败，请重试",
  "页面.岗位.获取链接": "获取链接",
  "页面.岗位.薪资": "薪资",
  "页面.岗位.薪资时间单位": "薪资时间单位",
  "页面.岗位.薪资结算单位": "薪资结算单位",
  "页面.岗位.薪资结算单位说明": "按薪资结算单位筛选",
  "页面.岗位.薪资说明": "薪资范围拼接时间单位展示；最小、最大均为空时显示为面谈",
  "页面.岗位.薪资面议": "薪资面议",
  "页面.岗位.被联系次数": "被联系次数",
  "页面.岗位.被联系次数说明": "C 端用户查看该岗位联系方式的次数，点击可查看被联系用户列表",
  "页面.岗位.被联系用户": "岗位被联系用户",
  "页面.岗位.被联系用户带标题": "被联系用户：{title}",
  "页面.岗位.证书资质": "证书资质",
  "页面.岗位.该岗位不在当前列表条件下": "该岗位不在当前列表条件下",
  "页面.岗位.该批次暂无任务": "该批次暂无任务",
  "页面.岗位.该日暂无岗位数据": "该日暂无岗位数据",
  "页面.岗位.详细描述": "详细描述",
  "页面.岗位.请从列表点击审核打开": "请从列表中点击「审核」打开",
  "页面.岗位.请先加载列表后再定位": "请先加载列表后再定位",
  "页面.岗位.请先选择一个数据段": "请先从左侧选择一个数据段",
  "页面.岗位.请先选择操作分配人": "请先选择操作分配人",
  "页面.岗位.请求失败": "请求失败",
  "页面.岗位.请输入任职要求": "请输入任职要求",
  "页面.岗位.请输入企业全称": "请输入企业全称（2-200 字符）",
  "页面.岗位.请输入最大薪资": "请输入最大薪资（整数，步长 100）",
  "页面.岗位.请输入最小薪资": "请输入最小薪资（整数，步长 100）",
  "页面.岗位.请输入完整编号区间": "请输入完整的岗位编号区间",
  "页面.岗位.请输入审核备注": "请输入审核备注",
  "页面.岗位.请输入岗位ID或编号": "请输入岗位 ID 或岗位编号（如 20250226-000001）",
  "页面.岗位.请输入岗位名称": "请输入岗位名称",
  "页面.岗位.请输入岗位地址非标地址": "请输入岗位地址（非标地址）",
  "页面.岗位.请输入岗位职责": "请输入岗位职责",
  "页面.岗位.请输入工作职责": "请输入工作职责",
  "页面.岗位.请输入工作要求": "请输入工作要求",
  "页面.岗位.请输入技能要求": "请输入技能要求",
  "页面.岗位.请输入招聘人数": "请输入招聘人数",
  "页面.岗位.请输入福利待遇": "请输入福利待遇",
  "页面.岗位.请输入职位描述": "请输入岗位职责",
  "页面.岗位.请输入联系人姓名": "请输入联系人姓名",
  "页面.岗位.请输入联系电话": "请输入联系电话",
  "页面.岗位.请输入至少2个字符": "请输入至少2个字符进行搜索",
  "页面.岗位.请输入至少一个岗位编号": "请至少输入一个岗位编号",
  "页面.岗位.请输入证书资质": "请输入证书资质",
  "页面.岗位.请输入飞机号": "请输入岗位联系人飞机号",
  "页面.岗位.请选择不通过原因": "请选择不通过原因",
  "页面.岗位.请选择分配人": "请选择分配人",
  "页面.岗位.请选择学历要求": "请选择学历要求",
  "页面.岗位.请选择岗位标签可多选": "请选择岗位标签（可多选）",
  "页面.岗位.请选择岗位标签后展示岗位分组配置": "选择岗位标签后展示命中的岗位分组配置",
  "页面.岗位.请选择工作地点": "请选择工作地点",
  "页面.岗位.请选择工作性质": "请选择工作性质",
  "页面.岗位.请选择工作福利标签可多选": "请选择词库标签（可多选，含求职门槛、福利保障、工作模式、平台状态等分类）",
  "页面.岗位.请选择工作经验要求": "请选择工作经验要求",
  "页面.岗位.请选择工种": "请选择工种",
  "页面.岗位.请选择开始时间": "请选择开始时间",
  "页面.岗位.请选择性别要求": "请选择性别要求",
  "页面.岗位.请选择结束时间": "请选择结束时间",
  "页面.岗位.请选择编号日期": "请选择编号日期",
  "页面.岗位.请选择至少一个不通过原因": "请至少选择一个审核不通过原因",
  "页面.岗位.请选择至少一条岗位": "请至少选择一条岗位",
  "页面.岗位.请选择薪资时间单位": "请选择薪资时间单位",
  "页面.岗位.请选择薪资结算单位": "请选择薪资结算单位",
  "页面.岗位.输入内容": "输入内容",
  "页面.岗位.运营录入": "运营录入",
  "页面.岗位.返回上一条": "返回上一条",
  "页面.岗位.返回非成功": "返回非成功",
  "页面.岗位.选择一组进行操作": "选择一组进行分配或取消分配",
  "页面.岗位.选择分配人并确认": "选择分配人并确认",
  "页面.岗位.选择日期": "选择日期",
  "页面.岗位.部分成功部分失败": "任务执行完毕，{ok} 个执行成功，{fail} 个执行失败",
  "页面.岗位.链接已复制": "链接已复制到剪贴板",
  "页面.岗位.非结构化企业名称": "非结构化企业名称（与关联企业无关）",
  "页面.岗位.面谈": "面谈",
  "页面.岗位.预览返回异常": "预览返回异常",
  "页面.岗位.飞机号": "飞机号",
  "页面.岗位.首次提交翻译时间": "首次提交翻译时间",
  "页面.岗位.高中": "高中",
  "页面.岗位.高棉语标签": "高棉语 (km_KH)",
  "页面.岗位分组配置.一级组名称": "一级组名称",
  "页面.岗位分组配置.一级组集合": "一级组集合",
  "页面.岗位分组配置.关联工种": "关联工种",
  "页面.岗位分组配置.关联工种最多5个": "最多选择5个关联工种",
  "页面.岗位分组配置.关联工种说明": "仅可选择子级组，最多5个",
  "页面.岗位分组配置.子级组列表": "子级组列表",
  "页面.岗位分组配置.子级组名称": "子级组名称",
  "页面.岗位分组配置.子级组集合": "子级组集合",
  "页面.岗位分组配置.子级组集合ID": "子级组集合ID",
  "页面.岗位分组配置.子级组集合ID不能为空": "子级组集合ID不能为空",
  "页面.岗位分组配置.子级组集合ID不能重复": "子级组集合ID不能重复",
  "页面.岗位分组配置.子级组集合为空说明": "当前一级组集合下没有可选标签，请选择包含下级标签的一级标签。",
  "页面.岗位分组配置.子级组集合只允许来自一级组集合的子集": "子级组集合只能从一级组集合的下级标签中选择",
  "页面.岗位分组配置.子级集合为空说明": "当前一级组集合下没有可选标签，请选择包含下级标签的一级标签。",
  "页面.岗位分组配置.岗位分组配置管理": "岗位分组配置管理",
  "页面.岗位分组配置.排序": "排序",
  "页面.岗位分组配置.排序顺序说明": "排序顺序（数字越小越靠前）",
  "页面.岗位分组配置.数据已同步服务端提示": "配置已保存至服务端数据库，与岗位标签字典联动校验。",
  "页面.岗位分组配置.新增一级组": "新增一级组",
  "页面.岗位分组配置.是否热门": "是否热门",
  "页面.岗位分组配置.添加子级组": "添加子级组",
  "页面.岗位分组配置.热门": "热门",
  "页面.岗位分组配置.热门排序": "热门排序",
  "页面.岗位分组配置.热门排序说明": "数字越小越靠前，仅热门列表生效",
  "页面.岗位分组配置.状态": "状态",
  "页面.岗位分组配置.确认删除该配置": "确认删除该岗位分组配置吗？",
  "页面.岗位分组配置.编辑一级组": "编辑一级组",
  "页面.岗位分组配置.请至少添加一个子级组": "请至少添加一个子级组",
  "页面.岗位分组配置.请输入一级组名称": "请输入一级组名称",
  "页面.岗位分组配置.请输入子级组名称": "请输入子级组名称",
  "页面.岗位分组配置.请输入排序": "请输入排序",
  "页面.岗位分组配置.请输入热门排序": "请输入热门排序",
  "页面.岗位分组配置.请选择一级组集合": "请选择一级组集合",
  "页面.岗位分组配置.请选择关联工种": "请选择关联工种",
  "页面.岗位分组配置.请选择子级组集合": "请选择子级组集合",
  "页面.岗位分组配置.请选择子级组集合ID": "请选择子级组集合ID",
  "页面.岗位分组配置.非热门": "非热门",
  "页面.岗位生成.CamHR": "CamHR",
  "页面.岗位生成.config_category_id": "分类 ID",
  "页面.岗位生成.config_category_name": "分类名称",
  "页面.岗位生成.config_entity_id": "数据源 ID",
  "页面.岗位生成.config_entity_name": "数据源名称",
  "页面.岗位生成.Dashboard.一级汇总": "一级汇总",
  "页面.岗位生成.Dashboard.不通过原因分布": "不通过原因分布",
  "页面.岗位生成.Dashboard.任务失败率": "任务失败率",
  "页面.岗位生成.Dashboard.任务失败率说明": "执行失败数 ÷ (成功+失败)，无完成时为 0",
  "页面.岗位生成.Dashboard.任务完成率": "任务完成率",
  "页面.岗位生成.Dashboard.任务完成率说明": "（执行成功+执行失败）÷ 总任务数",
  "页面.岗位生成.Dashboard.任务成功率": "任务成功率",
  "页面.岗位生成.Dashboard.任务成功率说明": "执行成功数 ÷ (成功+失败)，无完成时为 0",
  "页面.岗位生成.Dashboard.任务级未创建原因": "任务级未创建原因",
  "页面.岗位生成.Dashboard.任务级未创建原因说明": "无岗位槽位的任务级原因（如内容无关、未提取到岗位等）",
  "页面.岗位生成.Dashboard.任务维度统计": "任务维度统计",
  "页面.岗位生成.Dashboard.任务进行中占比": "任务进行中占比",
  "页面.岗位生成.Dashboard.任务进行中占比说明": "（待执行+执行中）÷ 总任务数",
  "页面.岗位生成.Dashboard.入口名称": "入口名称",
  "页面.岗位生成.Dashboard.入口按钮": "数据看板",
  "页面.岗位生成.Dashboard.全部外部": "全部外部数据源",
  "页面.岗位生成.Dashboard.全量暂无数据": "暂无数据",
  "页面.岗位生成.Dashboard.全量查询等待提示": "全量数据查询较慢，请耐心等待…",
  "页面.岗位生成.Dashboard.创建异常条数": "创建异常条数",
  "页面.岗位生成.Dashboard.创建异常条数说明": "岗位条创建过程异常的数量（reason 含 creation_failed）",
  "页面.岗位生成.Dashboard.占比": "占比",
  "页面.岗位生成.Dashboard.场景1": "单维度汇总",
  "页面.岗位生成.Dashboard.场景2": "全量 by 数据源/入口",
  "页面.岗位生成.Dashboard.实际创建岗位数": "实际创建岗位数",
  "页面.岗位生成.Dashboard.实际创建岗位数说明": "各任务生成的岗位 ID 数量之和",
  "页面.岗位生成.Dashboard.审核不通过": "审核不通过",
  "页面.岗位生成.Dashboard.审核通过": "审核通过",
  "页面.岗位生成.Dashboard.审核通过率": "审核通过率",
  "页面.岗位生成.Dashboard.岗位创建率": "岗位创建率",
  "页面.岗位生成.Dashboard.岗位创建率说明": "实际创建岗位数 ÷ 任务数，无任务时为 0",
  "页面.岗位生成.Dashboard.岗位条创建异常率": "岗位条创建异常率",
  "页面.岗位生成.Dashboard.岗位条创建异常率说明": "创建异常条数 ÷ 总槽位数",
  "页面.岗位生成.Dashboard.岗位条创建转化率": "岗位条创建转化率",
  "页面.岗位生成.Dashboard.岗位条创建转化率说明": "已创建条数 ÷ 总槽位数，无槽位时为 0",
  "页面.岗位生成.Dashboard.岗位条结果排行": "岗位条结果排行",
  "页面.岗位生成.Dashboard.岗位条维度统计": "岗位条维度统计",
  "页面.岗位生成.Dashboard.已创建岗位审核": "已创建岗位审核",
  "页面.岗位生成.Dashboard.已创建条数": "已创建条数",
  "页面.岗位生成.Dashboard.已创建条数说明": "岗位条中已成功创建为岗位的数量（reason 含 created）",
  "页面.岗位生成.Dashboard.平均每任务创建岗位数": "平均每任务创建岗位数",
  "页面.岗位生成.Dashboard.平均每任务创建岗位数说明": "实际创建岗位数 ÷ 总任务数",
  "页面.岗位生成.Dashboard.平均每任务解析岗位条": "平均每任务解析岗位条",
  "页面.岗位生成.Dashboard.平均每任务解析岗位条说明": "总岗位槽位数 ÷ 总任务数",
  "页面.岗位生成.Dashboard.开始查询": "开始查询",
  "页面.岗位生成.Dashboard.弹窗标题": "外部数据源 · 岗位生成数据看板",
  "页面.岗位生成.Dashboard.待审": "待审",
  "页面.岗位生成.Dashboard.总任务数": "总任务数",
  "页面.岗位生成.Dashboard.总任务数说明": "时间与数据源范围内的任务总数",
  "页面.岗位生成.Dashboard.总岗位槽位数": "总岗位槽位数",
  "页面.岗位生成.Dashboard.总岗位槽位数说明": "所有任务解析出的岗位条数量之和",
  "页面.岗位生成.Dashboard.成功任务中已创建占比": "成功任务中「至少创建一条」占比",
  "页面.岗位生成.Dashboard.成功任务中已创建占比说明": "结果类型=已创建岗位 的任务数 ÷ 执行成功任务数",
  "页面.岗位生成.Dashboard.成功任务中未创建占比": "成功任务中「未创建」占比",
  "页面.岗位生成.Dashboard.成功任务中未创建占比说明": "结果类型=未创建 的任务数 ÷ 执行成功任务数",
  "页面.岗位生成.Dashboard.按数据源分组": "按数据源分组",
  "页面.岗位生成.Dashboard.按状态分布": "按状态分布",
  "页面.岗位生成.Dashboard.按状态分布说明": "任务执行状态：待执行 / 执行中 / 执行成功 / 执行失败",
  "页面.岗位生成.Dashboard.按结果类型分布": "按结果类型分布",
  "页面.岗位生成.Dashboard.按结果类型分布说明": "仅对已结束任务：已创建岗位 / 未创建（不符合）/ 执行异常",
  "页面.岗位生成.Dashboard.数据源池": "数据源池",
  "页面.岗位生成.Dashboard.数据源池说明": "不选则返回全部数据源；选择后返回该池下所有 source/entity 行",
  "页面.岗位生成.Dashboard.数据源维度": "数据源维度",
  "页面.岗位生成.Dashboard.数据源维度说明": "按渠道筛选，不选则统计全部外部数据源",
  "页面.岗位生成.Dashboard.数据统计时间": "数据统计时间",
  "页面.岗位生成.Dashboard.时间区间": "时间区间",
  "页面.岗位生成.Dashboard.时间区间说明": "统计该时间段内创建的任务与岗位数据",
  "页面.岗位生成.Dashboard.暂无排行数据": "暂无排行数据",
  "页面.岗位生成.Dashboard.未创建原因细分": "未创建原因细分",
  "页面.岗位生成.Dashboard.未创建原因细分说明": "各原因码对应的未创建岗位条数（与原因码筛选一致）",
  "页面.岗位生成.Dashboard.未创建岗位条占比": "未创建岗位条占比",
  "页面.岗位生成.Dashboard.未创建岗位条占比说明": "未创建岗位条数 ÷ 总岗位槽位数",
  "页面.岗位生成.Dashboard.未创建岗位条数": "未创建岗位条数",
  "页面.岗位生成.Dashboard.未创建岗位条数说明": "总岗位槽位数 - 已创建条数 - 创建异常条数",
  "页面.岗位生成.Dashboard.条入口": "条入口",
  "页面.岗位生成.Dashboard.查看看板": "查看看板",
  "页面.岗位生成.Dashboard.查询条件": "查询条件",
  "页面.岗位生成.Dashboard.核心概览": "核心概览",
  "页面.岗位生成.Dashboard.每已完成任务创建岗位数": "每已完成任务创建岗位数",
  "页面.岗位生成.Dashboard.每已完成任务创建岗位数说明": "实际创建岗位数 ÷（执行成功+执行失败）",
  "页面.岗位生成.Dashboard.绝对值": "绝对值",
  "页面.岗位生成.Dashboard.自定义": "自定义",
  "页面.岗位生成.Dashboard.获取失败": "获取看板数据失败",
  "页面.岗位生成.Dashboard.请选择时间": "请选择时间区间",
  "页面.岗位生成.Dashboard.转化率与漏斗": "转化率与漏斗",
  "页面.岗位生成.Dashboard.选择条件": "选择查询条件",
  "页面.岗位生成.Dashboard.页面标题": "岗位数据看板",
  "页面.岗位生成.entity_type": "实体类型",
  "页面.岗位生成.entity_url": "实体链接",
  "页面.岗位生成.Facebook": "Facebook",
  "页面.岗位生成.LLM原始响应": "LLM 原始响应",
  "页面.岗位生成.LLM原始响应说明": "是否有 LLM 原始响应（调试用）",
  "页面.岗位生成.source_label": "来源名称",
  "页面.岗位生成.TG": "TG",
  "页面.岗位生成.任务ID说明": "JD 生成任务 ID，点击查看任务详情",
  "页面.岗位生成.任务创建时间": "任务创建时间",
  "页面.岗位生成.任务级原因码": "任务级原因码",
  "页面.岗位生成.任务队列统计": "任务队列统计",
  "页面.岗位生成.全部": "全部",
  "页面.岗位生成.全部外部": "全部外部",
  "页面.岗位生成.全部外部数据源": "全部外部数据源",
  "页面.岗位生成.其他": "其他",
  "页面.岗位生成.刷新": "刷新",
  "页面.岗位生成.原因码": "原因码",
  "页面.岗位生成.原因码.all_format_validation_failed": "所有岗位数据格式校验均失败",
  "页面.岗位生成.原因码.all_jd_creation_failed": "所有 JD 创建均失败",
  "页面.岗位生成.原因码.content_irrelevant": "内容与岗位招聘无关",
  "页面.岗位生成.原因码.creation_failed": "创建失败",
  "页面.岗位生成.原因码.duplicate": "与已有岗位重复",
  "页面.岗位生成.原因码.format_validation_failed": "单条岗位格式校验失败",
  "页面.岗位生成.原因码.missing_contact_phone": "缺少联系电话",
  "页面.岗位生成.原因码.missing_location": "缺少工作地点",
  "页面.岗位生成.原因码.missing_title": "缺少岗位名称",
  "页面.岗位生成.原因码.no_jobs_extracted": "未提取到任何岗位信息",
  "页面.岗位生成.原因码.salary_max_invalid": "最大薪资无效",
  "页面.岗位生成.原因码.salary_min_invalid": "最小薪资必须是非负数字",
  "页面.岗位生成.原因码.salary_negative": "薪资范围不能为负数",
  "页面.岗位生成.原因码.salary_range_invalid": "薪资范围不合理",
  "页面.岗位生成.原因码.salary_type_invalid": "薪资范围必须是数字类型",
  "页面.岗位生成.原因码.title_length_invalid": "岗位名称长度不合理",
  "页面.岗位生成.原因码.unknown": "未知原因",
  "页面.岗位生成.原因码分组.任务级": "任务级",
  "页面.岗位生成.原因码分组.单条岗位": "单条岗位",
  "页面.岗位生成.原因码分组.质量去重": "质量/去重",
  "页面.岗位生成.原因码占位": "输入原因码，如 duplicate",
  "页面.岗位生成.后台创建": "后台创建",
  "页面.岗位生成.外部": "外部",
  "页面.岗位生成.外部数据源": "外部数据源",
  "页面.岗位生成.外部数据源渠道": "外部数据源渠道",
  "页面.岗位生成.岗位ID说明": "生成的岗位 ID 列表（仅成功创建时有值，点击打开岗位详情抽屉）",
  "页面.岗位生成.岗位明细": "岗位明细",
  "页面.岗位生成.已创建岗位": "已创建岗位",
  "页面.岗位生成.并发": "并发",
  "页面.岗位生成.开始时间": "开始时间",
  "页面.岗位生成.待执行": "待执行",
  "页面.岗位生成.总计": "总计",
  "页面.岗位生成.我创建的": "我创建的",
  "页面.岗位生成.我创建的说明": "仅查看当前登录用户创建的任务",
  "页面.岗位生成.执行中": "执行中",
  "页面.岗位生成.执行失败": "执行失败",
  "页面.岗位生成.执行开始时间": "执行开始时间",
  "页面.岗位生成.执行异常": "执行异常",
  "页面.岗位生成.执行成功": "执行成功",
  "页面.岗位生成.执行结束时间": "执行结束时间",
  "页面.岗位生成.批次ID": "批次ID",
  "页面.岗位生成.批次ID说明": "所属批次 ID，点击查看该批次下所有任务",
  "页面.岗位生成.按任务状态筛选": "按任务状态筛选，可多选",
  "页面.岗位生成.按原因码筛选": "按原因码筛选（多选为或）",
  "页面.岗位生成.按数据源筛选": "按数据源筛选",
  "页面.岗位生成.按结果类型筛选": "按结果类型筛选，可多选",
  "页面.岗位生成.数据源": "数据源",
  "页面.岗位生成.数据源信息": "数据源信息",
  "页面.岗位生成.无": "无",
  "页面.岗位生成.暂无数据": "暂无数据",
  "页面.岗位生成.有": "有",
  "页面.岗位生成.未创建不符合": "未创建（不符合）",
  "页面.岗位生成.来源": "来源",
  "页面.岗位生成.来源说明": "任务来源",
  "页面.岗位生成.槽位": "槽位",
  "页面.岗位生成.状态": "状态",
  "页面.岗位生成.状态说明": "任务执行状态",
  "页面.岗位生成.结束时间": "结束时间",
  "页面.岗位生成.结果原因": "结果原因",
  "页面.岗位生成.结果原因说明": "任务级或岗位明细原因码",
  "页面.岗位生成.结果类型": "结果类型",
  "页面.岗位生成.结果类型说明": "执行结果类型",
  "页面.岗位生成.自动刷新": "自动刷新",
  "页面.岗位生成.获取队列统计失败": "获取队列统计失败",
  "页面.岗位生成.请选择数据源": "请选择数据源",
  "页面.岗位生成.请选择状态": "请选择状态",
  "页面.岗位生成.请选择结果类型": "请选择结果类型",
  "页面.岗位生成.运营后台": "运营后台",
  "页面.岗位生成.错误信息": "错误信息",
  "页面.岗位生成.错误信息说明": "执行失败时的错误信息",
  "页面.岗位生成.队列": "队列",
  "页面.岗位黑名单.作用字段": "作用字段",
  "页面.岗位黑名单.保存失败": "保存失败",
  "页面.岗位黑名单.关键词": "内容关键词",
  "页面.岗位黑名单.关键词占位": "模糊匹配配置内容",
  "页面.岗位黑名单.内容占位": "仅填一个电话号码、一个飞机号或一个企业名称",
  "页面.岗位黑名单.内容字段说明": "一次新增只能填 1 个值；与岗位同字段归一化后精确相等才命中。多个电话/飞机号/公司名必须拆成多条配置，勿在同一格用 /、|、空格拼接。t.me/+ 群邀请链不支持。",
  "页面.岗位黑名单.创建失败": "创建失败",
  "页面.岗位黑名单.创建成功建议预览": "已创建。建议先预览命中再启用。",
  "页面.岗位黑名单.删除": "删除",
  "页面.岗位黑名单.删除失败": "删除失败",
  "页面.岗位黑名单.删除失败重试": "删除失败，请重试",
  "页面.岗位黑名单.加载中": "加载中…",
  "页面.岗位黑名单.加载配置失败": "加载配置失败",
  "页面.岗位黑名单.包含已软删岗位": "统计含已软删岗位",
  "页面.岗位黑名单.启用": "启用规则",
  "页面.岗位黑名单.启用状态": "启用",
  "页面.岗位黑名单.命中数量": "命中岗位数",
  "页面.岗位黑名单.命中条数": "命中条数",
  "页面.岗位黑名单.命中记录": "命中记录",
  "页面.岗位黑名单.填写说明简": "一条配置只填一个值；多号码请拆多条。电话可含 +、空格、横线；飞机号可用 t.me 链接或 @用户名；t.me/+ 邀请链不支持；勿用 |、/ 把多个值写在一格。",
  "页面.岗位黑名单.填写说明链": "填写规范",
  "页面.岗位黑名单.备注": "备注",
  "页面.岗位黑名单.备注清空说明": "留空并保存可清空备注（传空字符串）",
  "页面.岗位黑名单.字段.企业名称": "企业名称",
  "页面.岗位黑名单.字段.联系电话": "联系电话",
  "页面.岗位黑名单.字段.飞机号": "飞机号（Telegram）",
  "页面.岗位黑名单.岗位ID占位": "精确筛选岗位",
  "页面.岗位黑名单.岗位侧归一化值": "岗位侧归一化值",
  "页面.岗位黑名单.已保存": "已保存",
  "页面.岗位黑名单.已停用": "已停用",
  "页面.岗位黑名单.已删除": "已删除",
  "页面.岗位黑名单.已启用": "已启用",
  "页面.岗位黑名单.归一化比对值": "归一化比对值",
  "页面.岗位黑名单.操作": "操作",
  "页面.岗位黑名单.新建内容占位": "【填写规范 — 请在本框输入要拦截的一个具体值】\n\n① 只填 1 个值。多个电话、多个飞机号、多个公司名 → 请分别「新建配置」多条，不要写在一格里。\n② 电话：可含 +、空格、括号、横线等；禁止用 /、| 把多个号码拼在一起（如 014/093）。\n③ 飞机号：可填 https://t.me/xxx 或 @xxx；t.me/+ 形式的群邀请链接不支持。\n④ 企业名称：整段精确匹配；不要把两个公司名用 |、/、空格拼在同一格。\n⑤ 保存后与岗位同字段归一化再比对，须完全一致才会命中。",
  "页面.岗位黑名单.新建内容标签附注": "请先阅读框内灰色提示，再填写要拉黑的一个值",
  "页面.岗位黑名单.新建配置": "新建配置",
  "页面.岗位黑名单.是否立即预览": "是否立即预览命中数量？",
  "页面.岗位黑名单.更新失败": "更新失败",
  "页面.岗位黑名单.更新失败重试": "更新失败，请重试",
  "页面.岗位黑名单.状态已更新": "状态已更新",
  "页面.岗位黑名单.确认删除配置": "确定软删除该黑名单配置？",
  "页面.岗位黑名单.示例岗位": "示例岗位 ID",
  "页面.岗位黑名单.示例条数": "示例条数上限",
  "页面.岗位黑名单.筛选岗位ID": "岗位 ID",
  "页面.岗位黑名单.编辑": "编辑",
  "页面.岗位黑名单.编辑配置": "编辑黑名单配置",
  "页面.岗位黑名单.规则ID": "规则 ID",
  "页面.岗位黑名单.记录ID": "命中记录 ID",
  "页面.岗位黑名单.请填写内容": "请填写黑名单内容",
  "页面.岗位黑名单.配置ID": "配置 ID",
  "页面.岗位黑名单.配置内容": "黑名单内容",
  "页面.岗位黑名单.配置列表": "黑名单配置",
  "页面.岗位黑名单.配置原文": "配置原文",
  "页面.岗位黑名单.重新统计": "重新统计",
  "页面.岗位黑名单.页面标题": "岗位黑名单",
  "页面.岗位黑名单.预览命中": "预览命中",
  "页面.岗位黑名单.预览失败": "预览失败",
  "页面.岗位黑名单.预览失败重试": "预览失败，请重试",
  "页面.工种搜索反馈.匿名ID": "匿名 ID",
  "页面.工种搜索反馈.处理": "处理",
  "页面.工种搜索反馈.处理反馈": "处理反馈",
  "页面.工种搜索反馈.处理成功": "处理成功",
  "页面.工种搜索反馈.处理状态": "处理状态",
  "页面.工种搜索反馈.已处理": "已处理",
  "页面.工种搜索反馈.已忽略": "已忽略",
  "页面.工种搜索反馈.平台": "平台",
  "页面.工种搜索反馈.待处理": "待处理",
  "页面.工种搜索反馈.提交时间": "提交时间",
  "页面.工种搜索反馈.搜索词": "搜索词",
  "页面.工种搜索反馈.操作": "操作",
  "页面.工种搜索反馈.来源页面": "来源页面",
  "页面.工种搜索反馈.状态": "状态",
  "页面.工种搜索反馈.用户ID": "用户 ID",
  "页面.工种搜索反馈.语言": "语言",
  "页面.工种搜索反馈.运营备注": "运营备注",
  "页面.工种搜索反馈.页面标题": "工种搜索反馈",
  "页面.布局.用户布局标题": "AI 驱动的新一代招聘平台",
  "页面.推送测试.App版本": "App 版本",
  "页面.推送测试.Facebook不符合条件": "该用户当前无法接收 Facebook 测试推送",
  "页面.推送测试.Facebook仅Push说明": "不限制 Facebook App ID，只测试通知到达和点击唤起 App；不会自动创建弹窗测试资格，也不会直接跳转第三方账号页。",
  "页面.推送测试.Facebook仅最新设备": "预览与正式任务一致，只选择最近注册的一个有效设备。",
  "页面.推送测试.Facebook原因.已迁移": "该 Facebook 身份已经迁移到当前 App ID。",
  "页面.推送测试.Facebook原因.无设备": "该用户没有有效的移动推送设备。",
  "页面.推送测试.Facebook原因.无身份": "未找到有效的 Facebook 登录身份或用户状态不可触达。",
  "页面.推送测试.Facebook原因.未知": "资格校验未通过。",
  "页面.推送测试.Facebook完整联调说明": "不限制 Facebook App ID。非旧身份会在发送时自动开启 24 小时独立测试轮次，App 可完整测试弹窗和登录，真实 provider_tenant 不会改变。",
  "页面.推送测试.Facebook当前Tenant": "当前 tenant",
  "页面.推送测试.Facebook正式规则说明": "正式 17:00 任务仍只推送旧 Facebook tenant；本页面是独立测试入口，不改变正式候选范围和每日频控。",
  "页面.推送测试.Facebook正式资格": "真实旧身份资格",
  "页面.推送测试.Facebook测试模式": "测试模式",
  "页面.推送测试.Facebook测试模式.仅Push": "仅测试 Push 送达",
  "页面.推送测试.Facebook测试模式.完整联调": "完整重授权联调（推荐）",
  "页面.推送测试.Facebook测试轮次": "独立测试轮次 / 失效时间",
  "页面.推送测试.Facebook真实发送提醒": "请先预览资格；真实发送只会立即通知预览命中的最新有效设备。",
  "页面.推送测试.Facebook确认发送说明": "通知会立即发送到该用户最近注册的一个有效设备，并写入独立的后台测试投递记录；不会占用正式每日频控。",
  "页面.推送测试.Facebook确认发送说明.仅Push": "通知会立即发送到最新有效设备，不创建测试轮次；仅验证 Push 到达和点击唤起 App。若真实资格为无需迁移，则不弹窗也不跳转。",
  "页面.推送测试.Facebook确认发送说明.完整联调": "通知会立即发送到最新有效设备。若用户不属于旧 App ID，服务端会自动开启独立测试轮次；完成授权不会修改真实 Facebook 身份。",
  "页面.推送测试.Facebook符合条件": "该用户可以接收 Facebook 测试推送",
  "页面.推送测试.Facebook结束轮次": "结束测试轮次",
  "页面.推送测试.Facebook结束轮次成功": "测试轮次已结束。",
  "页面.推送测试.Facebook结束轮次确认": "结束当前测试轮次？",
  "页面.推送测试.Facebook身份Tenant": "身份 tenant",
  "页面.推送测试.Facebook运行配置": "Facebook 重新授权运行配置",
  "页面.推送测试.Facebook重新授权": "Facebook 重新授权",
  "页面.推送测试.Facebook重置轮次": "重置测试轮次",
  "页面.推送测试.Facebook重置轮次成功": "测试轮次已重置，请重新预览后发送。",
  "页面.推送测试.Facebook重置轮次确认": "结束现有轮次并创建新的 24 小时测试轮次？",
  "页面.推送测试.仅预览": "仅预览",
  "页面.推送测试.促活策略": "促活策略",
  "页面.推送测试.最近注册": "最近注册",
  "页面.推送测试.功能通知": "功能通知",
  "页面.推送测试.加载岗位失败": "加载岗位失败",
  "页面.推送测试.加载选项失败": "加载推送选项失败",
  "页面.推送测试.匿名用户": "匿名用户",
  "页面.推送测试.匿名用户ID": "匿名用户 ID",
  "页面.推送测试.参数.企业ID": "企业 ID",
  "页面.推送测试.参数.会话ID": "会话 ID",
  "页面.推送测试.参数.岗位": "岗位",
  "页面.推送测试.参数.工作经历ID": "工作经历 ID",
  "页面.推送测试.参数.工种": "工种",
  "页面.推送测试.参数.工种名称": "工种名称",
  "页面.推送测试.参数.教育经历ID": "教育经历 ID",
  "页面.推送测试.参数.来源": "来源",
  "页面.推送测试.参数.标签页": "标签页",
  "页面.推送测试.参数.模块": "简历模块",
  "页面.推送测试.参数.简历ID": "简历 ID",
  "页面.推送测试.参数.链接": "链接",
  "页面.推送测试.参数必填": "请填写{name}",
  "页面.推送测试.发送到设备": "发送到设备",
  "页面.推送测试.发送失败": "推送失败：成功 {success}，失败 {failed}",
  "页面.推送测试.发送成功": "推送任务已执行",
  "页面.推送测试.可选设置": "可选设置",
  "页面.推送测试.合同Profile": "合同 Profile",
  "页面.推送测试.合同版本": "合同版本",
  "页面.推送测试.否": "否",
  "页面.推送测试.岗位数量": "岗位数量",
  "页面.推送测试.岗位数量说明": "用于包含岗位数量的通知文案。",
  "页面.推送测试.已发送": "已发送",
  "页面.推送测试.投递状态.失败": "失败",
  "页面.推送测试.投递状态.已发送": "已发送",
  "页面.推送测试.投递状态.已跳过": "已跳过",
  "页面.推送测试.投递状态.重复": "重复",
  "页面.推送测试.投递状态.预览": "预览",
  "页面.推送测试.推送配置": "推送配置",
  "页面.推送测试.搜索岗位": "搜索已发布岗位",
  "页面.推送测试.支持路由数": "支持 {count} 个路由",
  "页面.推送测试.无需额外参数": "此类型无需填写额外参数。",
  "页面.推送测试.是": "是",
  "页面.推送测试.暂无结果": "填写配置后先生成预览",
  "页面.推送测试.未上报": "未上报",
  "页面.推送测试.标题正文成对": "标题和正文必须同时填写",
  "页面.推送测试.模板文案说明": "标题和正文留空时，使用所选语言对应的系统模板；填写时必须成对填写。",
  "页面.推送测试.消息类型": "消息类型",
  "页面.推送测试.状态": "状态",
  "页面.推送测试.用户ID": "用户 ID",
  "页面.推送测试.登录用户": "登录用户",
  "页面.推送测试.目标与内容": "目标与内容",
  "页面.推送测试.目标身份": "目标身份",
  "页面.推送测试.真实发送提醒": "“发送到设备”会立即触发真实通知；建议先预览。",
  "页面.推送测试.确认发送": "确认发送",
  "页面.推送测试.确认发送标题": "确认发送真实通知？",
  "页面.推送测试.确认发送说明": "通知会立即发送到该身份名下的全部有效设备，并写入推送记录。",
  "页面.推送测试.结果": "推送结果",
  "页面.推送测试.自定义标题": "自定义标题",
  "页面.推送测试.自定义正文": "自定义正文",
  "页面.推送测试.角标数量": "角标数量",
  "页面.推送测试.设备合同": "设备合同",
  "页面.推送测试.设备统计": "设备统计",
  "页面.推送测试.设备统计值": "共 {total} 台，成功 {success}，失败 {failed}",
  "页面.推送测试.请求失败": "操作失败，请检查配置后重试",
  "页面.推送测试.请输入匿名用户ID": "请输入匿名用户 ID",
  "页面.推送测试.请输入用户ID": "请输入用户 ID",
  "页面.推送测试.请选择参数": "请选择或填写{name}",
  "页面.推送测试.请选择消息类型": "请选择消息类型",
  "页面.推送测试.路由参数": "业务参数",
  "页面.推送测试.路由已降级": "路由降级：{requested} → {actual}",
  "页面.推送测试.选择工种": "选择工种",
  "页面.推送测试.通知ID": "通知 ID",
  "页面.推送测试.通知ID说明": "用于幂等控制；留空时自动生成。",
  "页面.推送测试.通知语言": "通知语言",
  "页面.推送测试.部分发送失败": "部分设备推送失败：成功 {success}，失败 {failed}",
  "页面.推送测试.页面标题": "移动推送测试",
  "页面.推送测试.页面说明": "向指定登录用户或匿名用户预览并发送真实移动通知。",
  "页面.推送测试.页面路由": "页面路由",
  "页面.推送测试.预览": "预览",
  "页面.推送测试.预览成功": "预览已生成",
  "页面.查询表格.万": "万",
  "页面.查询表格.上次调度时间": "上次调度时间",
  "页面.查询表格.基本信息": "基本信息",
  "页面.查询表格.已选择": "已选择",
  "页面.查询表格.开始时间": "开始时间",
  "页面.查询表格.批量删除": "批量删除",
  "页面.查询表格.批量审批": "批量审批",
  "页面.查询表格.描述": "描述",
  "页面.查询表格.操作": "操作",
  "页面.查询表格.新建": "新建",
  "页面.查询表格.新建规则": "新建规则",
  "页面.查询表格.服务调用次数": "服务调用次数",
  "页面.查询表格.服务调用次数总计": "服务调用次数总计",
  "页面.查询表格.标题": "查询表格",
  "页面.查询表格.状态": "状态",
  "页面.查询表格.状态.关闭": "关闭",
  "页面.查询表格.状态.已上线": "已上线",
  "页面.查询表格.状态.异常": "异常",
  "页面.查询表格.状态.运行中": "运行中",
  "页面.查询表格.监控对象": "监控对象",
  "页面.查询表格.规则名称": "规则名称",
  "页面.查询表格.规则名称必填": "规则名称为必填项",
  "页面.查询表格.规则名称标签": "规则名称",
  "页面.查询表格.规则描述占位": "请输入至少五个字符",
  "页面.查询表格.规则描述必填": "请输入至少五个字符的规则描述！",
  "页面.查询表格.规则描述标签": "规则描述",
  "页面.查询表格.规则模板": "规则模板",
  "页面.查询表格.规则类型": "规则类型",
  "页面.查询表格.规则配置": "规则配置",
  "页面.查询表格.订阅警报": "订阅警报",
  "页面.查询表格.设定调度周期": "设定调度周期",
  "页面.查询表格.请输入异常原因": "请输入异常原因！",
  "页面.查询表格.请输入规则名称": "请输入规则名称！",
  "页面.查询表格.请选择开始时间": "请选择开始时间！",
  "页面.查询表格.配置": "配置",
  "页面.查询表格.配置规则属性": "配置规则属性",
  "页面.查询表格.项": "项",
  "页面.欢迎.主标题": "欢迎使用 DodoJob 运营后台",
  "页面.欢迎.了解antd": "了解 ant design",
  "页面.欢迎.了解antd描述": "antd 是基于 Ant Design 设计体系的 React UI 组件库，主要用于研发企业级中后台产品。",
  "页面.欢迎.了解Pro": "了解 Pro Components",
  "页面.欢迎.了解Pro描述": "ProComponents 是一个基于 Ant Design 做了更高抽象的模板组件，以 一个组件就是一个页面为开发理念，为中后台开发带来更好的体验。",
  "页面.欢迎.了解umi": "了解 umi",
  "页面.欢迎.了解umi描述": "umi 是一个可扩展的企业级前端应用框架,umi 以路由为基础的，同时支持配置式路由和约定式路由，保证路由的功能完备，并以此进行功能扩展。",
  "页面.欢迎.了解更多": "了解更多",
  "页面.欢迎.副标题": "DodoJob 运营管理后台，基于 Umi + React + Ant Design Pro 构建，为运营团队提供高效的管理工具。",
  "页面.欢迎.重型组件提示": "更快更强的重型组件，已经发布。",
  "页面.求职用户.3到64字符唯一": "3-64 字符，唯一",
  "页面.求职用户.上传时间": "上传时间",
  "页面.求职用户.专业": "专业",
  "页面.求职用户.个人基础信息": "个人基础信息",
  "页面.求职用户.中文": "中文",
  "页面.求职用户.中文能力": "中文能力≥",
  "页面.求职用户.会员有效期": "存量会员有效期（兼容）",
  "页面.求职用户.会员有效期说明": "仅用于存量用户旧额度兼容；新发放道具以道具批次有效期为准。",
  "页面.求职用户.会员权益": "会员权益",
  "页面.求职用户.会员权益更新成功": "会员权益更新成功",
  "页面.求职用户.会员权益配置说明": "仅 B 用户可配置。岗位发布消耗道具；删除岗位不会返还已使用的道具。",
  "页面.求职用户.保存会员权益失败": "保存会员权益失败，请重试",
  "页面.求职用户.全部": "全部",
  "页面.求职用户.全部简历": "全部简历",
  "页面.求职用户.公司": "公司",
  "页面.求职用户.公开状态": "公开状态",
  "页面.求职用户.公开状态说明": "draft（草稿）/ private（已下架）/ published（已发布）",
  "页面.求职用户.公海未关联": "公海（未关联）",
  "页面.求职用户.公海池": "公海池",
  "页面.求职用户.关键词": "关键词",
  "页面.求职用户.关键词搜索": "关键词搜索",
  "页面.求职用户.关键词说明": "姓名、自我介绍、核心技能、工作经历 任一模糊匹配",
  "页面.求职用户.内容摘要说明": "性别、姓名、年龄、学历、首条工作经历；hover 可查看完整 JSON",
  "页面.求职用户.内容范围": "内容范围",
  "页面.求职用户.内容范围说明": "只搜草稿 / 只搜发布 / 全部",
  "页面.求职用户.出生年月": "出生年月",
  "页面.求职用户.创建": "创建",
  "页面.求职用户.创建失败": "创建失败",
  "页面.求职用户.创建开始时间": "创建开始时间",
  "页面.求职用户.创建成功": "创建成功",
  "页面.求职用户.创建时间": "创建时间",
  "页面.求职用户.创建时间标签": "创建时间",
  "页面.求职用户.创建时间说明": "创建时间，hover 显示原始值",
  "页面.求职用户.创建用户": "创建用户",
  "页面.求职用户.创建结束时间": "创建结束时间",
  "页面.求职用户.加载会员权益失败": "加载会员权益失败，请重试",
  "页面.求职用户.加载求职意向详情": "加载求职意向详情...",
  "页面.求职用户.加载用户详情": "加载用户详情...",
  "页面.求职用户.加载简历详情": "加载简历详情...",
  "页面.求职用户.原因": "原因",
  "页面.求职用户.发岗上限": "发岗上限",
  "页面.求职用户.发岗上限不能小于已发岗数": "发岗上限不能小于累计已发岗数 {count}",
  "页面.求职用户.发岗上限说明": "该账号终身累计可创建的岗位数量上限，不得小于累计已发岗数",
  "页面.求职用户.发布内容": "发布内容",
  "页面.求职用户.发送岗位加急道具": "发送岗位加急道具",
  "页面.求职用户.发送岗位加急道具失败": "发送失败，请重试",
  "页面.求职用户.发送岗位加急道具成功": "岗位加急道具已发送",
  "页面.求职用户.发送岗位加急道具确认": "确认向 {username} 发送 1 个岗位加急道具？有效期 30 天。",
  "页面.求职用户.发送岗位发布道具": "发送岗位发布道具",
  "页面.求职用户.发送岗位发布道具失败": "发送失败，请重试",
  "页面.求职用户.发送岗位发布道具成功": "岗位发布道具已发送",
  "页面.求职用户.发送岗位发布道具确认": "确认向 {username} 发送 1 个岗位发布道具？有效期 30 天。",
  "页面.求职用户.发送简历联系道具": "发送简历联系道具",
  "页面.求职用户.发送简历联系道具失败": "发送失败，请重试",
  "页面.求职用户.发送简历联系道具成功": "简历联系道具已发送",
  "页面.求职用户.发送简历联系道具确认": "确认向 {username} 发送 1 个简历联系道具？有效期 30 天。",
  "页面.求职用户.只搜发布": "只搜发布",
  "页面.求职用户.只搜草稿": "只搜草稿",
  "页面.求职用户.基本信息": "基本信息",
  "页面.求职用户.头像": "头像",
  "页面.求职用户.女": "女",
  "页面.求职用户.姓名": "姓名",
  "页面.求职用户.姓名说明": "模糊匹配 personal_info.name",
  "页面.求职用户.学历": "学历",
  "页面.求职用户.学历说明": "education 中任意一条的 education_level",
  "页面.求职用户.学校": "学校",
  "页面.求职用户.审核时间": "审核时间",
  "页面.求职用户.审核来源": "审核来源",
  "页面.求职用户.审核状态": "审核状态",
  "页面.求职用户.密码": "密码",
  "页面.求职用户.密码至少8字符": "密码至少 8 个字符",
  "页面.求职用户.密码需包含字母和数字": "需同时包含字母和数字",
  "页面.求职用户.岁": "岁",
  "页面.求职用户.岗位加急道具": "岗位加急道具",
  "页面.求职用户.岗位加急道具余额": "当前可用：{count} 个",
  "页面.求职用户.岗位加急道具说明": "每次发送 1 个，发放后 30 天内有效；记录可在权益流水查看。",
  "页面.求职用户.岗位发布道具": "岗位发布道具",
  "页面.求职用户.岗位发布道具余额": "当前可用：{count} 个",
  "页面.求职用户.岗位发布道具说明": "每次发送 1 个，发放后 30 天内有效；记录可在权益流水查看。",
  "页面.求职用户.工作内容": "工作内容",
  "页面.求职用户.工作经历": "工作经历",
  "页面.求职用户.已下架": "已下架",
  "页面.求职用户.已关联用户": "已关联用户",
  "页面.求职用户.已发布": "已发布",
  "页面.求职用户.已封禁": "已封禁",
  "页面.求职用户.已选用户": "已选用户",
  "页面.求职用户.已选用户数量": "{count} 个",
  "页面.求职用户.已通过": "已通过",
  "页面.求职用户.已驳回": "已驳回",
  "页面.求职用户.待审核": "待审核",
  "页面.求职用户.性别": "性别",
  "页面.求职用户.意向ID": "意向ID",
  "页面.求职用户.意向ID标签": "意向 ID",
  "页面.求职用户.意向ID说明": "求职意向 ID（NanoID），点击查看详情",
  "页面.求职用户.手机号": "手机号",
  "页面.求职用户.批量减少道具": "批量减少道具",
  "页面.求职用户.批量发放道具原因": "运营后台批量发放道具",
  "页面.求职用户.批量处理成功": "已处理 {count} 个用户",
  "页面.求职用户.批量处理部分失败": "成功 {successCount} 个，失败 {failedCount} 个",
  "页面.求职用户.批量扣减道具原因": "运营后台批量扣减道具",
  "页面.求职用户.批量添加道具": "批量添加道具",
  "页面.求职用户.批量调整道具失败": "批量调整失败，请重试",
  "页面.求职用户.招聘者": "招聘者",
  "页面.求职用户.括号无": "（无）",
  "页面.求职用户.搜索用户名昵称邮箱手机号": "搜索用户名、昵称、邮箱、手机号",
  "页面.求职用户.操作": "操作",
  "页面.求职用户.教育经历": "教育经历",
  "页面.求职用户.数量": "数量",
  "页面.求职用户.文件名": "文件名",
  "页面.求职用户.文件大小": "文件大小",
  "页面.求职用户.文件无法读取": "文件无法读取",
  "页面.求职用户.无关键信息": "无关键信息",
  "页面.求职用户.时间": "时间",
  "页面.求职用户.昵称": "昵称",
  "页面.求职用户.暂无数据": "暂无数据",
  "页面.求职用户.更新时间": "更新时间",
  "页面.求职用户.更新时间标签": "更新时间",
  "页面.求职用户.更新时间说明": "更新时间，hover 显示原始值",
  "页面.求职用户.期望地点": "期望地点",
  "页面.求职用户.期望地点标签": "期望地点",
  "页面.求职用户.期望地点说明": "精确匹配期望求职地点（地区）",
  "页面.求职用户.期望岗位": "期望岗位",
  "页面.求职用户.期望岗位标签": "期望岗位",
  "页面.求职用户.期望薪资上限": "期望薪资上限(≤)",
  "页面.求职用户.期望薪资上限说明": "筛选意向的期望薪资最大值 <= 该值（美元）",
  "页面.求职用户.期望薪资下限": "期望薪资下限(≥)",
  "页面.求职用户.期望薪资下限说明": "筛选意向的期望薪资最小值 >= 该值（美元）",
  "页面.求职用户.期望薪资美元": "期望薪资（美元）",
  "页面.求职用户.期望薪资美元标签": "期望薪资（美元）",
  "页面.求职用户.期望薪资范围": "期望薪资范围",
  "页面.求职用户.未提供jobIntentionId或jobIntention": "未提供 jobIntentionId 或 jobIntention",
  "页面.求职用户.未提供resumeId或resume": "未提供 resumeId 或 resume",
  "页面.求职用户.未提供userId或user": "未提供 userId 或 user",
  "页面.求职用户.未激活": "未激活",
  "页面.求职用户.来源文件": "来源文件",
  "页面.求职用户.柬文": "柬文",
  "页面.求职用户.柬文能力": "柬文能力≥",
  "页面.求职用户.核心技能": "核心技能",
  "页面.求职用户.核心技能说明": "逗号分隔，匹配包含任一技能的简历",
  "页面.求职用户.求职岗位列表": "求职岗位列表",
  "页面.求职用户.求职岗位筛选": "求职岗位筛选",
  "页面.求职用户.求职意向": "求职意向",
  "页面.求职用户.求职意向信息": "求职意向信息",
  "页面.求职用户.求职意向详情": "求职意向详情",
  "页面.求职用户.求职档案": "求职档案",
  "页面.求职用户.求职者": "求职者",
  "页面.求职用户.注册方式": "注册方式",
  "页面.求职用户.注册方式BotStart": "Bot /start",
  "页面.求职用户.注册方式GoogleOAuth": "Google 登录",
  "页面.求职用户.注册方式TelegramOAuth": "Telegram 登录",
  "页面.求职用户.注册方式后台创建": "后台创建",
  "页面.求职用户.注册方式后台手动": "后台手动",
  "页面.求职用户.注册方式小程序授权": "小程序授权",
  "页面.求职用户.注册方式说明": "注册方式：miniapp_auth / google_oauth / telegram_oauth / admin / admin_manual / telegram_bot_start（历史数据可能为空）",
  "页面.求职用户.注册端App": "App",
  "页面.求职用户.注册端TelegramBot": "Telegram Bot",
  "页面.求职用户.注册端Telegram小程序": "Telegram 小程序",
  "页面.求职用户.注册端管理后台": "管理后台",
  "页面.求职用户.注册端类型": "注册端",
  "页面.求职用户.注册端类型说明": "注册时客户端类型：app / tg-miniapp / admin / telegram_bot（历史数据可能为空）",
  "页面.求职用户.活跃": "活跃",
  "页面.求职用户.状态": "状态",
  "页面.求职用户.状态说明": "状态：active（活跃）/ inactive（未激活）/ blocked（已封禁）",
  "页面.求职用户.用户ID": "用户ID",
  "页面.求职用户.用户ID标签": "用户 ID",
  "页面.求职用户.用户ID点击详情": "用户 ID（NanoID），点击查看详情",
  "页面.求职用户.用户ID过滤": "用户 ID 过滤",
  "页面.求职用户.用户ID过滤公海": "用户 ID 过滤（公海简历为空），点击查看用户详情",
  "页面.求职用户.用户名": "用户名",
  "页面.求职用户.用户名3到64字符": "用户名 3-64 个字符",
  "页面.求职用户.用户管理": "用户管理",
  "页面.求职用户.用户详情": "用户详情",
  "页面.求职用户.用户身份说明": "用户身份：seeker（求职者）/ employer（招聘者）",
  "页面.求职用户.电话": "电话",
  "页面.求职用户.男": "男",
  "页面.求职用户.确认发送": "确认发送",
  "页面.求职用户.确认通过附件": "确认通过该简历附件？",
  "页面.求职用户.确认驳回附件": "确认驳回该简历附件？",
  "页面.求职用户.空": "（空）",
  "页面.求职用户.简历ID": "简历ID",
  "页面.求职用户.简历ID标签": "简历 ID",
  "页面.求职用户.简历ID点击详情": "简历 ID（NanoID），点击查看详情",
  "页面.求职用户.简历ID说明": "简历 ID 过滤，点击查看简历详情",
  "页面.求职用户.简历管理": "简历管理",
  "页面.求职用户.简历联系道具": "简历联系道具",
  "页面.求职用户.简历联系道具余额": "当前可用：{count} 个",
  "页面.求职用户.简历联系道具说明": "每次发送 1 个，发放后 30 天内有效；记录可在权益流水查看。",
  "页面.求职用户.简历详情": "简历详情",
  "页面.求职用户.简历附件审核": "简历附件审核",
  "页面.求职用户.累计已发岗数": "累计已发岗数：{count}",
  "页面.求职用户.累计已发岗数说明": "包含已删除岗位；删除岗位不会释放发岗额度",
  "页面.求职用户.编辑会员权益标题": "编辑 {username} 的会员权益",
  "页面.求职用户.美元": "美元",
  "页面.求职用户.职位": "职位",
  "页面.求职用户.联系次数": "联系次数",
  "页面.求职用户.联系次数说明": "B 用户在人才库中可联系简历的次数，最小为 0",
  "页面.求职用户.能力说明": "0-4",
  "页面.求职用户.自我介绍": "自我介绍",
  "页面.求职用户.自我介绍说明": "模糊匹配",
  "页面.求职用户.至今": "至今",
  "页面.求职用户.至少8个字符": "至少 8 个字符",
  "页面.求职用户.英文": "英文",
  "页面.求职用户.英文能力": "英文能力≥",
  "页面.求职用户.草稿": "草稿",
  "页面.求职用户.草稿内容": "草稿内容",
  "页面.求职用户.获取详情失败": "获取详情失败",
  "页面.求职用户.证书": "证书",
  "页面.求职用户.证书名称": "证书名称",
  "页面.求职用户.证书图片": "证书图片",
  "页面.求职用户.该简历暂无发布内容": "该简历暂无发布内容（未发布或已下架）",
  "页面.求职用户.该简历暂无草稿内容": "该简历暂无草稿内容",
  "页面.求职用户.语言等级商务": "商务",
  "页面.求职用户.语言等级基础": "基础",
  "页面.求职用户.语言等级无": "无",
  "页面.求职用户.语言等级日常": "日常",
  "页面.求职用户.语言等级母语": "母语",
  "页面.求职用户.语言能力": "语言能力",
  "页面.求职用户.请求失败": "请求失败",
  "页面.求职用户.请输入原因": "请输入原因",
  "页面.求职用户.请输入发岗上限": "请输入发岗上限",
  "页面.求职用户.请输入密码": "请输入密码",
  "页面.求职用户.请输入数量": "请输入数量",
  "页面.求职用户.请输入用户名": "请输入用户名",
  "页面.求职用户.请输入联系次数": "请输入联系次数",
  "页面.求职用户.请选择会员有效期": "请选择会员有效期",
  "页面.求职用户.请选择地区": "请选择地区",
  "页面.求职用户.请选择岗位可多选": "请选择岗位（可多选）",
  "页面.求职用户.请选择道具类型": "请选择道具类型",
  "页面.求职用户.账号信息": "账号信息",
  "页面.求职用户.账号手机号": "账号手机号",
  "页面.求职用户.账号邮箱": "账号邮箱",
  "页面.求职用户.账号限制.封禁": "封禁",
  "页面.求职用户.账号限制.封禁成功": "已封禁该用户",
  "页面.求职用户.账号限制.已封禁": "已封禁",
  "页面.求职用户.账号限制.已禁言": "已禁言",
  "页面.求职用户.账号限制.操作失败": "操作失败，请重试",
  "页面.求职用户.账号限制.正常": "正常",
  "页面.求职用户.账号限制.状态": "运营限制",
  "页面.求职用户.账号限制.状态说明": "当前账号的禁言或封禁状态",
  "页面.求职用户.账号限制.确认封禁": "确认封禁该用户？",
  "页面.求职用户.账号限制.确认封禁说明": "用户将无法访问 App 需登录接口，但仍可提交申诉。",
  "页面.求职用户.账号限制.确认禁言": "确认禁言该用户？",
  "页面.求职用户.账号限制.确认禁言说明": "用户仍可登录，但不能发送 IM 消息。",
  "页面.求职用户.账号限制.确认解除": "确认解除当前账号限制？",
  "页面.求职用户.账号限制.禁言": "禁言",
  "页面.求职用户.账号限制.禁言成功": "已禁言该用户",
  "页面.求职用户.账号限制.解除": "解除",
  "页面.求职用户.账号限制.解除成功": "已解除账号限制",
  "页面.求职用户.身份": "身份",
  "页面.求职用户.身份筛选": "身份筛选",
  "页面.求职用户.选填最大128字符": "选填，最大 128 字符",
  "页面.求职用户.选填唯一": "选填，唯一",
  "页面.求职用户.通过审核": "通过",
  "页面.求职用户.道具类型": "道具类型",
  "页面.求职用户.邮箱": "邮箱",
  "页面.求职用户.附件ID": "附件 ID",
  "页面.求职用户.附件审核失败": "审核失败，请重试",
  "页面.求职用户.附件审核成功": "审核结果已更新",
  "页面.求职用户.附件预览失败": "获取预览失败，请重试",
  "页面.求职用户.非简历文件": "非简历文件",
  "页面.求职用户.颁发日期": "颁发日期",
  "页面.求职用户.颁发机构": "颁发机构",
  "页面.求职用户.预览附件": "预览",
  "页面.求职用户.驳回原因": "驳回原因",
  "页面.求职用户.驳回附件": "驳回",
  "页面.求职用户.默认求职者": "默认求职者",
  "页面.热门分组配置.上传配图提示": "上传标签配图",
  "页面.热门分组配置.岗位标签集": "岗位标签集",
  "页面.热门分组配置.岗位标签集支持说明": "一级仅用于展开，只能选择二级，可多选",
  "页面.热门分组配置.拖拽调整展示顺序": "拖拽调整展示顺序",
  "页面.热门分组配置.排序": "排序",
  "页面.热门分组配置.新增标签": "新增标签",
  "页面.热门分组配置.标签名称": "标签名称",
  "页面.热门分组配置.正在更新": "正在更新...",
  "页面.热门分组配置.正在更新排序": "正在更新排序",
  "页面.热门分组配置.状态": "状态",
  "页面.热门分组配置.确认删除该标签": "确认删除该标签吗？",
  "页面.热门分组配置.编辑标签": "编辑标签",
  "页面.热门分组配置.请输入排序": "请输入排序",
  "页面.热门分组配置.请输入标签名称": "请输入标签名称",
  "页面.热门分组配置.请选择岗位标签集": "请选择岗位标签集",
  "页面.热门分组配置.配图": "配图",
  "页面.登录.失败": "登录失败，请重试！",
  "页面.登录.密码占位": "请输入密码",
  "页面.登录.密码必填": "请输入密码！",
  "页面.登录.忘记密码": "忘记密码",
  "页面.登录.成功": "登录成功！",
  "页面.登录.提交": "登录",
  "页面.登录.用户名占位": "请输入用户名",
  "页面.登录.用户名必填": "请输入用户名!",
  "页面.登录.自动登录": "自动登录",
  "页面.登录.账户或密码错误": "账户或密码错误",
  "页面.登录.账户登录": "账户密码登录",
  "页面.管理.仅管理员可看": "此页面仅管理员可查看",
  "页面.管理.使用区块": "使用区块",
  "页面.管理.标题": "DodoJob 运营后台",
  "页面.管理.添加页面提示": "想添加更多页面？请参考",
  "页面.配置.地区.Tab标准": "标准地区",
  "页面.配置.地区.Tab非标": "非标地区",
  "页面.配置.地区.上移": "上移",
  "页面.配置.地区.下移": "下移",
  "页面.配置.地区.仅一二级可设热门": "仅一级或二级行政区可设置热门与排序",
  "页面.配置.地区.仅一二级可设热门提示": "仅一级或二级行政区可设置",
  "页面.配置.地区.可选一级或二级": "可选一级或二级行政区",
  "页面.配置.地区.同步": "同步",
  "页面.配置.地区.同步成功条": "同步成功，共同步 {count} 条地区数据",
  "页面.配置.地区.否": "否",
  "页面.配置.地区.启用国家": "启用国家",
  "页面.配置.地区.启用国家同步后可启用": "启用国家（同步后可启用）",
  "页面.配置.地区.启用失败": "启用失败",
  "页面.配置.地区.启用失败重试": "启用失败，请重试",
  "页面.配置.地区.启用成功": "启用成功",
  "页面.配置.地区.地区排序说明": "共 {count} 个地区。上移/下移只调整同级顺序，保存后 C 端全量地区树与热门地区都会按该顺序展示。",
  "页面.配置.地区.地区树": "地区树",
  "页面.配置.地区.多语言名称": "多语言名称",
  "页面.配置.地区.展示排序": "展示排序",
  "页面.配置.地区.展示排序提示": "数字越小越靠前，C 端全量地区和热门地区都会按此排序",
  "页面.配置.地区.已启用": "已启用",
  "页面.配置.地区.已在热门列表中": "已在热门列表中",
  "页面.配置.地区.当前仅支持同步柬埔寨": "当前仅支持同步柬埔寨（KH）地区",
  "页面.配置.地区.当前仅支持启用柬埔寨": "当前仅支持启用柬埔寨（KH）",
  "页面.配置.地区.排序": "排序",
  "页面.配置.地区.是": "是",
  "页面.配置.地区.是否启用": "是否启用",
  "页面.配置.地区.显示名称": "显示名称",
  "页面.配置.地区.显示名称说明": "后台展示逻辑：优先 display_text.zh_CN（中文），其次 display_text.en_US（英文），否则使用标准名称 name_en",
  "页面.配置.地区.暂无可排序地区": "暂无可排序地区",
  "页面.配置.地区.暂无可用国家": "暂无可用国家，请确认后端已配置国家列表。",
  "页面.配置.地区.暂无热门地区": "暂无热门地区，可从上方选择一级或二级行政区添加",
  "页面.配置.地区.标准名称": "标准名称",
  "页面.配置.地区.标准名称说明": "英文主名称，来自数据锚文件，不可编辑",
  "页面.配置.地区.添加": "添加",
  "页面.配置.地区.热门": "热门",
  "页面.配置.地区.热门排序": "热门排序",
  "页面.配置.地区.热门排序提示": "数字越小越靠前，仅当设为热门时生效",
  "页面.配置.地区.热门顺序说明": "顺序即热门展示顺序，并复用为地区展示排序。可上移/下移调整，空列表保存将清空该国所有热门。",
  "页面.配置.地区.移除": "移除",
  "页面.配置.地区.管理地区排序": "管理地区排序",
  "页面.配置.地区.管理热门城市": "管理热门城市",
  "页面.配置.地区.级别": "级别",
  "页面.配置.地区.编码": "编码",
  "页面.配置.地区.编辑地区": "编辑地区",
  "页面.配置.地区.自动生成多语言": "自动生成多语言",
  "页面.配置.地区.该国家尚未同步": "该国家尚未同步地区数据，请先点击「同步」从数据锚文件同步到数据库。",
  "页面.配置.地区.请填写不小于0的整数": "请填写不小于 0 的整数",
  "页面.配置.地区.请输入名称": "请输入{label}名称",
  "页面.配置.岗位反馈类型.创建时间": "创建时间",
  "页面.配置.岗位反馈类型.创建时间说明": "创建时间，hover 显示原始值",
  "页面.配置.岗位反馈类型.名称说明": "名称（value 字段）",
  "页面.配置.岗位反馈类型.岗位反馈类型ID": "岗位反馈类型 ID",
  "页面.配置.岗位反馈类型.岗位反馈类型管理": "岗位反馈类型管理",
  "页面.配置.岗位反馈类型.成功删除N个": "成功删除 {n} 个岗位反馈类型",
  "页面.配置.岗位反馈类型.成功删除部分失败": "成功删除 {ok} 个，失败 {fail} 个",
  "页面.配置.岗位反馈类型.排序": "排序",
  "页面.配置.岗位反馈类型.排序说明": "排序顺序（数字越小越靠前）",
  "页面.配置.岗位反馈类型.是否启用": "是否启用",
  "页面.配置.岗位反馈类型.正在删除N个": "正在删除 {n} 个岗位反馈类型...",
  "页面.配置.岗位反馈类型.正在更新": "正在更新",
  "页面.配置.岗位反馈类型.正在添加": "正在添加",
  "页面.配置.岗位反馈类型.确定删除岗位反馈类型": "确定要删除这个岗位反馈类型吗？",
  "页面.配置.岗位投诉类型.创建时间": "创建时间",
  "页面.配置.岗位投诉类型.创建时间说明": "创建时间，hover 显示原始值",
  "页面.配置.岗位投诉类型.名称说明": "名称（value 字段）",
  "页面.配置.岗位投诉类型.岗位投诉类型ID": "岗位投诉类型 ID",
  "页面.配置.岗位投诉类型.岗位投诉类型管理": "岗位投诉类型管理",
  "页面.配置.岗位投诉类型.成功删除N个": "成功删除 {n} 个岗位投诉类型",
  "页面.配置.岗位投诉类型.成功删除部分失败": "成功删除 {ok} 个，失败 {fail} 个",
  "页面.配置.岗位投诉类型.排序": "排序",
  "页面.配置.岗位投诉类型.排序说明": "排序顺序（数字越小越靠前）",
  "页面.配置.岗位投诉类型.是否启用": "是否启用",
  "页面.配置.岗位投诉类型.正在删除N个": "正在删除 {n} 个岗位投诉类型...",
  "页面.配置.岗位投诉类型.正在更新": "正在更新",
  "页面.配置.岗位投诉类型.正在添加": "正在添加",
  "页面.配置.岗位投诉类型.确定删除岗位投诉类型": "确定要删除这个岗位投诉类型吗？",
  "页面.配置.岗位标签.Tab标准": "标准岗位标签",
  "页面.配置.岗位标签.Tab非标": "非标岗位标签",
  "页面.配置.岗位标签.多语言显示文本": "多语言显示文本",
  "页面.配置.岗位标签.多语言显示文本说明": "可选，用于多语言场景。可以手动填写或使用自动生成功能",
  "页面.配置.岗位标签.导出全量": "导出全量",
  "页面.配置.岗位标签.导出密码": "密码",
  "页面.配置.岗位标签.导出成功": "导出成功",
  "页面.配置.岗位标签.导出标准岗位标签全量": "导出标准岗位标签全量",
  "页面.配置.岗位标签.导出用户名": "用户名",
  "页面.配置.岗位标签.导出非标岗位标签全量": "导出非标岗位标签全量",
  "页面.配置.岗位标签.岗位数": "岗位数",
  "页面.配置.岗位标签.岗位数说明": "使用该标签的岗位数量",
  "页面.配置.岗位标签.岗位标签管理": "岗位标签管理",
  "页面.配置.岗位标签.成功删除N个": "成功删除 {n} 个岗位标签",
  "页面.配置.岗位标签.成功删除部分失败": "成功删除 {ok} 个，失败 {fail} 个",
  "页面.配置.岗位标签.按原始文本关键词搜索": "输入关键词模糊搜索",
  "页面.配置.岗位标签.新建岗位标签": "新建岗位标签",
  "页面.配置.岗位标签.新建标签": "新建标签",
  "页面.配置.岗位标签.是否启用": "是否启用",
  "页面.配置.岗位标签.标签ID": "标签ID",
  "页面.配置.岗位标签.标签代码": "标签代码",
  "页面.配置.岗位标签.标签名称": "标签名称",
  "页面.配置.岗位标签.标签名称value": "标签名称（value 字段）",
  "页面.配置.岗位标签.标签名称不能超过128": "标签名称不能超过128个字符",
  "页面.配置.岗位标签.标签名称多语言": "标签名称（多语言）",
  "页面.配置.岗位标签.标签名称必填": "标签名称是必填项",
  "页面.配置.岗位标签.标签配图": "标签配图",
  "页面.配置.岗位标签.标签配图tips": "先 1:1 裁剪，系统自动生成 1x（88×88px）与 2x（176×176px）并上传。建议直接选用 176×176 或更大图片，裁剪后最短边 ≥176px，清晰度最佳。",
  "页面.配置.岗位标签.正在删除N个": "正在删除 {n} 个岗位标签...",
  "页面.配置.岗位标签.正在更新": "正在更新",
  "页面.配置.岗位标签.正在添加": "正在添加",
  "页面.配置.岗位标签.添加子级": "添加子级",
  "页面.配置.岗位标签.确定删除岗位标签": "确定要删除这个岗位标签吗？删除后子级也会被删除",
  "页面.配置.岗位标签.编辑岗位标签": "编辑岗位标签",
  "页面.配置.岗位标签.至少填写一个语言": "至少需要填写一个语言的显示文本",
  "页面.配置.岗位标签.至少填写中文或英文": "至少需要填写一个语言的显示文本（中文或英文）",
  "页面.配置.岗位标签.请输入导出密码": "请输入密码",
  "页面.配置.岗位标签.请输入导出用户名": "请输入用户名",
  "页面.配置.岗位标签.请输入标签名称": "请输入标签名称，例如：软件工程师",
  "页面.配置.岗位标签.选择图片并裁剪": "选择图片并裁剪为 1:1",
  "页面.配置.岗位标签.配图": "配图",
  "页面.配置.岗位标签.配图尺寸过小": "裁剪后图片最短边至少需要 {min}px，当前为 {current}px，请换一张更大的图或缩小裁剪区域",
  "页面.配置.岗位标签.配图规格说明": "1x {w1}×{h1}px，2x {w2}×{h2}px，先裁剪后上传",
  "页面.配置.岗位标签.非标出现次数": "出现次数",
  "页面.配置.岗位标签.非标出现次数说明": "便于数据分析与排序",
  "页面.配置.岗位标签.非标原始文本": "原始文本",
  "页面.配置.岗位标签.非标原始文本说明": "未命中标准标签时的原始文本",
  "页面.配置.岗位标签.非标类型": "类型",
  "页面.配置.岗位标签.非标类型岗位标签": "岗位标签",
  "页面.配置.岗位标签.非标类型工作地点": "工作地点",
  "页面.配置.游客联系限制.中度不能小于轻度": "中度联系阈值不能小于轻度联系阈值",
  "页面.配置.游客联系限制.中度联系": "中度联系",
  "页面.配置.游客联系限制.中度联系阈值": "中度联系阈值",
  "页面.配置.游客联系限制.加载失败": "加载配置失败",
  "页面.配置.游客联系限制.加载失败重试": "加载配置失败，请重试",
  "页面.配置.游客联系限制.周": "周",
  "页面.配置.游客联系限制.周期单位": "周期单位",
  "页面.配置.游客联系限制.周期数值": "周期数值",
  "页面.配置.游客联系限制.天": "天",
  "页面.配置.游客联系限制.当前生效配置": "当前生效配置",
  "页面.配置.游客联系限制.月": "月",
  "页面.配置.游客联系限制.次": "次",
  "页面.配置.游客联系限制.正在保存": "正在保存配置...",
  "页面.配置.游客联系限制.统计周期": "统计周期",
  "页面.配置.游客联系限制.说明内容": "C 端通过 /api/v1/config 获取此配置，用于判断游客在统计周期内联系岗位的次数等级。",
  "页面.配置.游客联系限制.说明标题": "C 端读取口径",
  "页面.配置.游客联系限制.请输入中度阈值": "请输入中度联系阈值",
  "页面.配置.游客联系限制.请输入周期数值": "请输入周期数值",
  "页面.配置.游客联系限制.请输入轻度阈值": "请输入轻度联系阈值",
  "页面.配置.游客联系限制.请选择周期单位": "请选择周期单位",
  "页面.配置.游客联系限制.轻度联系": "轻度联系",
  "页面.配置.游客联系限制.轻度联系阈值": "轻度联系阈值",
  "页面.配置.游客联系限制.重新加载": "重新加载",
  "页面.配置.游客联系限制.页面标题": "游客联系限制",
  "页面.配置.游客联系限制.频次限制": "频次限制",
  "页面.配置.热搜词配置.创建时间": "创建时间",
  "页面.配置.热搜词配置.创建时间说明": "创建时间，hover 显示原始值",
  "页面.配置.热搜词配置.成功删除N个": "成功删除 {n} 个热搜词",
  "页面.配置.热搜词配置.成功删除部分失败": "成功删除 {ok} 个，失败 {fail} 个",
  "页面.配置.热搜词配置.排序": "排序",
  "页面.配置.热搜词配置.排序说明": "排序顺序（数字越小越靠前）",
  "页面.配置.热搜词配置.新建按钮": "新建热搜词",
  "页面.配置.热搜词配置.新建标题": "新建热搜词",
  "页面.配置.热搜词配置.是否启用": "是否启用",
  "页面.配置.热搜词配置.正在删除N个": "正在删除 {n} 个热搜词...",
  "页面.配置.热搜词配置.正在更新": "正在更新",
  "页面.配置.热搜词配置.正在添加": "正在添加",
  "页面.配置.热搜词配置.热搜词": "热搜词",
  "页面.配置.热搜词配置.热搜词ID": "热搜词 ID",
  "页面.配置.热搜词配置.热搜词说明": "字典 value 字段，固定写入 type=hot_search",
  "页面.配置.热搜词配置.确定删除热搜词": "确定要删除这个热搜词吗？",
  "页面.配置.热搜词配置.编辑标题": "编辑热搜词",
  "页面.配置.热搜词配置.请输入热搜词": "请输入热搜词",
  "页面.配置.热搜词配置.页面标题": "热搜词配置",
  "页面.配置.福利与保障标签.中文标签": "中文标签",
  "页面.配置.福利与保障标签.全部分类": "全部分类",
  "页面.配置.福利与保障标签.关键词": "关键词",
  "页面.配置.福利与保障标签.关键词说明": "按分类、编码或任一语言标签筛选",
  "页面.配置.福利与保障标签.分类.benefit_guarantee": "福利保障标签",
  "页面.配置.福利与保障标签.分类.job_requirement": "求职门槛标签",
  "页面.配置.福利与保障标签.分类.platform_status": "平台专属 / 状态标签",
  "页面.配置.福利与保障标签.分类.work_mode": "工作模式标签",
  "页面.配置.福利与保障标签.创建时间": "创建时间",
  "页面.配置.福利与保障标签.创建时间说明": "创建时间，hover 显示原始值",
  "页面.配置.福利与保障标签.字段必填": "此项为必填",
  "页面.配置.福利与保障标签.成功删除N个": "成功删除 {n} 个标签",
  "页面.配置.福利与保障标签.成功删除部分失败": "成功删除 {ok} 个，失败 {fail} 个",
  "页面.配置.福利与保障标签.排序": "排序",
  "页面.配置.福利与保障标签.排序说明": "数字越小越靠前",
  "页面.配置.福利与保障标签.新建按钮": "新建标签",
  "页面.配置.福利与保障标签.新建标题": "新建标签",
  "页面.配置.福利与保障标签.是否启用": "是否启用",
  "页面.配置.福利与保障标签.标签ID": "标签 ID",
  "页面.配置.福利与保障标签.标签分类": "标签分类",
  "页面.配置.福利与保障标签.正在删除N个": "正在删除 {n} 个标签...",
  "页面.配置.福利与保障标签.正在更新": "正在更新",
  "页面.配置.福利与保障标签.正在添加": "正在添加",
  "页面.配置.福利与保障标签.确定删除": "确定要删除该标签吗？已关联岗位的记录将保留关联 ID，但列表不再展示此项。",
  "页面.配置.福利与保障标签.编码": "编码",
  "页面.配置.福利与保障标签.编码只读说明": "创建后不可修改；岗位等关联存的是该编码",
  "页面.配置.福利与保障标签.编码说明": "由系统在创建时自动生成，用于接口与存储，不可手工修改",
  "页面.配置.福利与保障标签.编辑标题": "编辑标签",
  "页面.配置.福利与保障标签.英文标签": "英文标签",
  "页面.配置.福利与保障标签.页面标题": "标签词库",
  "页面.配置.福利与保障标签.高棉语标签": "高棉语标签",
  "页面.配置.销售联系方式.Telegram占位": "用户名、@用户名或 t.me 链接",
  "页面.配置.销售联系方式.Telegram标题": "Telegram",
  "页面.配置.销售联系方式.加载失败": "加载销售联系方式失败，请重试",
  "页面.配置.销售联系方式.启用": "启用",
  "页面.配置.销售联系方式.正在保存": "正在保存销售联系方式...",
  "页面.配置.销售联系方式.添加联系方式": "添加联系方式",
  "页面.配置.销售联系方式.电话占位": "例如：+855 12 345 678",
  "页面.配置.销售联系方式.电话标题": "电话",
  "页面.配置.销售联系方式.类型": "类型",
  "页面.配置.销售联系方式.联系方式": "联系方式",
  "页面.配置.销售联系方式.说明内容": "用于雇主岗位达到发布上限后的“联系销售”入口。Telegram 和电话均可添加多条，只有启用的联系方式会下发到 App。",
  "页面.配置.销售联系方式.说明标题": "App 展示规则",
  "页面.配置.销售联系方式.请输入Telegram": "请输入 Telegram 用户名",
  "页面.配置.销售联系方式.请输入电话": "请输入电话号码",
  "页面.配置.销售联系方式.重新加载": "重新加载",
  "页面.配置.销售联系方式.页面标题": "销售联系方式",
  "页面.首页金刚位.保存排序": "保存排序",
  "页面.首页金刚位.双页排序": "首页金刚位排序",
  "页面.首页金刚位.双页排序说明": "两页同时展示全部启用项。拖拽非固定项进行排序；固定项保持原位置，普通排序会自动跳过固定槽位。",
  "页面.首页金刚位.固定第N位": "固定第{position}位",
  "页面.首页金刚位.已是最前可调整位置": "已在最前可调整位置",
  "页面.首页金刚位.已移到最前": "已移到最前",
  "页面.首页金刚位.拖拽调整顺序": "拖拽调整顺序",
  "页面.首页金刚位.排序": "排序",
  "页面.首页金刚位.排序保存失败": "排序保存失败，请重试",
  "页面.首页金刚位.排序保存成功": "排序已保存",
  "页面.首页金刚位.排序已保存列表刷新失败": "排序已保存，但列表刷新失败，请刷新页面确认",
  "页面.首页金刚位.移到最前": "移到最前",
  "页面.首页金刚位.移到最前失败": "移到最前失败，已恢复原顺序",
  "页面.首页金刚位.第N页": "第 {page} 页",
  "页面.首页金刚位.顺序": "顺序",
  "顶栏.个人设置": "个人设置",
  "顶栏.帮助": "使用文档",
  "顶栏.搜索": "站内搜索",
  "顶栏.用户": "用户",
  "顶栏.角色": "角色",
  "顶栏.语言": "语言",
  "顶栏.退出登录": "退出登录",
  "顶栏.通知": "通知"
};
